webpackJsonp([0],{

/***/ "5dJC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"daily_summary":"daily_summary__4fQRV"};

/***/ }),

/***/ "76Ws":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1cNHE","updated_at":"updated_at__12mUU","updated_at_main":"updated_at_main__dAVdv","updated_at_paused":"updated_at_paused__2JYsU","time_updated":"time_updated__2CT_h","beacon":"beacon__1AqwB","beacon_success":"beacon_success__2Wuqc","beacon_error":"beacon_error__3NVie","beacon_stale":"beacon_stale__2FC5f"};

/***/ }),

/***/ "9ui9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"conditions_status":"conditions_status__KDbil","secondary_layout":"secondary_layout__K0c3c","final_layout":"final_layout__1WIPr","secondary_box":"secondary_box__1InEN","recent_obs_btns":"recent_obs_btns__2UWd4","recent_obs":"recent_obs__3Q8Eg"};

/***/ }),

/***/ "HgUS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"hourly_list":"hourly_list__1nv_L","hourly_list_note":"hourly_list_note__sIzE6","hourly_list_row":"hourly_list_row__1dUI1","hourly_list_head":"hourly_list_head__1Nepm","hourly_list_time_column":"hourly_list_time_column__1yZSq","hourly_list_temp_column":"hourly_list_temp_column__16x5Y","hourly_list_rain_column":"hourly_list_rain_column__11Bph","hourly_list_wind_column":"hourly_list_wind_column__-pHw7","hourly_list_gust_column":"hourly_list_gust_column__1-1n9","hourly_list_temperature_cell":"hourly_list_temperature_cell__2JWcA","hourly_list_wind_cell":"hourly_list_wind_cell__2KRKY","hourly_list_rain_cell":"hourly_list_rain_cell__3n5-r","hourly_list_raindrop":"hourly_list_raindrop__2Fipc"};

/***/ }),

/***/ "MB83":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("5dJC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_formatters__ = __webpack_require__("gNwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_convert_wind_bearing__ = __webpack_require__("Dqzv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handle_loading_and_error__ = __webpack_require__("/zgt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__table__ = __webpack_require__("5Xep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__card_date_label__ = __webpack_require__("iZj6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__highlight_values__ = __webpack_require__("C3gn");









/**
 * The DailySummary component is used to display a tabular summary of a particular day's
 * weather data summary.
 *
 * props:
 * - data: An object containing daily summary data, as returned by the api
 */

var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'High temperature'
);

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'Low temperature'
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'High wind gust'
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'Total rainfall'
);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('td', null);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'Mean temperature'
);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('td', null);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'High avg speed'
);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'Wind run'
);

var _ref10 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('td', null);

var _ref11 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'High rain rate'
);

var _ref12 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'High hourly rain'
);

var _ref13 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'High humidity'
);

var _ref14 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'Low humidity'
);

var _ref15 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'High dewpoint'
);

var _ref16 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'Low dewpoint'
);

var _ref17 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'High pressure'
);

var _ref18 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'td',
	null,
	'Low pressure'
);

var DailySummary = function DailySummary(props, context) {

	var units = context.userSettings.units;

	var formatters = {
		date: Object(__WEBPACK_IMPORTED_MODULE_2__utils_formatters__["j" /* getDateTimeFormatConverter */])('%Y-%m-%d', '%-d %B'),
		time: Object(__WEBPACK_IMPORTED_MODULE_2__utils_formatters__["j" /* getDateTimeFormatConverter */])('%H:%M', '%X'),
		temperature: function temperature(t) {
			return Object(__WEBPACK_IMPORTED_MODULE_2__utils_formatters__["f" /* formatTemperature */])(t, units.temperature);
		},
		rain: function rain(r) {
			return Object(__WEBPACK_IMPORTED_MODULE_2__utils_formatters__["e" /* formatRainfall */])(r, units.rain);
		},
		rainRate: function rainRate(r) {
			return Object(__WEBPACK_IMPORTED_MODULE_2__utils_formatters__["d" /* formatRainRate */])(r, units.rain);
		},
		windSpeed: function windSpeed(s) {
			return Object(__WEBPACK_IMPORTED_MODULE_2__utils_formatters__["i" /* formatWindSpeed */])(s, units.speed);
		},
		windGust: function windGust(g) {
			return Object(__WEBPACK_IMPORTED_MODULE_2__utils_formatters__["h" /* formatWindGust */])(g, units.speed);
		},
		pressure: function pressure(p) {
			return Object(__WEBPACK_IMPORTED_MODULE_2__utils_formatters__["c" /* formatPressure */])(p, units.pressure);
		}
	};

	var data = props.data,
	    excludeKeyStats = props.excludeKeyStats;


	var highTemperature = void 0,
	    lowTemperature = void 0,
	    highWindGust = void 0,
	    rainfall = void 0;

	if (excludeKeyStats) {

		highTemperature = null;
		lowTemperature = null;
		highWindGust = null;
		rainfall = null;
	} else {

		highTemperature = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			null,
			_ref,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_7__highlight_values__["a" /* HighlightHighTemperature */],
					null,
					formatters.temperature(data.highTemperature) + ('\xB0' + units.temperature)
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				formatters.time(data.highTemperatureTime)
			)
		);

		lowTemperature = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			null,
			_ref2,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_7__highlight_values__["b" /* HighlightLowTemperature */],
					null,
					formatters.temperature(data.lowTemperature) + ('\xB0' + units.temperature)
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				formatters.time(data.lowTemperatureTime)
			)
		);

		var highWindGustDirection = data.highWindGust > 0 ? Object(__WEBPACK_IMPORTED_MODULE_3__utils_convert_wind_bearing__["b" /* convertWindBearing8 */])(data.highWindGustBearing) + ' ' : '';

		highWindGust = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			null,
			_ref3,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_7__highlight_values__["e" /* HighlightWindGust */],
					null,
					'' + highWindGustDirection + formatters.windGust(data.highWindGust) + ' ' + units.speed
				)
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				formatters.time(data.highWindGustTime)
			)
		);

		rainfall = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'tr',
			null,
			_ref4,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'td',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					__WEBPACK_IMPORTED_MODULE_7__highlight_values__["d" /* HighlightRainfall */],
					null,
					formatters.rain(data.rainfall) + (' ' + units.rain)
				)
			),
			_ref5
		);
	}

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.daily_summary },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_6__card_date_label__["a" /* default */], { date: formatters.date(data.date) }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			__WEBPACK_IMPORTED_MODULE_5__table__["a" /* default */],
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'tbody',
				null,
				highTemperature,
				lowTemperature,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tr',
					null,
					_ref6,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							__WEBPACK_IMPORTED_MODULE_7__highlight_values__["c" /* HighlightMeanTemperature */],
							null,
							formatters.temperature(data.avgTemperature) + ('\xB0' + units.temperature)
						)
					),
					_ref7
				),
				highWindGust,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tr',
					null,
					_ref8,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.windSpeed(data.highWindSpeed) + (' ' + units.speed)
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.time(data.highWindSpeedTime)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tr',
					null,
					_ref9,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.windSpeed(data.windRun) + (' ' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_formatters__["a" /* convertSpeedUnitToWindRunUnit */])(units.speed))
					),
					_ref10
				),
				rainfall,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tr',
					null,
					_ref11,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.rainRate(data.highRainRate) + (' ' + units.rain + '/hr')
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.time(data.highRainRateTime)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tr',
					null,
					_ref12,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.rain(data.highHourlyRain) + (' ' + units.rain)
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.time(data.highHourlyRainTime)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tr',
					null,
					_ref13,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						data.highHumidity,
						'%'
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.time(data.highHumidityTime)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tr',
					null,
					_ref14,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						data.lowHumidity,
						'%'
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.time(data.lowHumidityTime)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tr',
					null,
					_ref15,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.temperature(data.highDewpoint) + ('\xB0' + units.temperature)
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.time(data.highDewpointTime)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tr',
					null,
					_ref16,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.temperature(data.lowDewpoint) + ('\xB0' + units.temperature)
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.time(data.lowDewpointTime)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tr',
					null,
					_ref17,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.pressure(data.highPressure) + (' ' + units.pressure)
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.time(data.highPressureTime)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'tr',
					null,
					_ref18,
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.pressure(data.lowPressure) + (' ' + units.pressure)
					),
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'td',
						null,
						formatters.time(data.lowPressureTime)
					)
				)
			)
		)
	);
};

// Export a wrapped component, where loading state and error are already handled
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__handle_loading_and_error__["a" /* default */])(DailySummary));

/***/ }),

/***/ "MBDq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"today_in_previous_years":"today_in_previous_years__IJE9A"};

/***/ }),

/***/ "N6T2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"date_label":"date_label__1GVD7"};

/***/ }),

/***/ "NDTo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sun_moon":"sun_moon__2dNeY"};

/***/ }),

/***/ "SAA0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"primary_layout":"primary_layout__OSonY","primary_box":"primary_box__21eC6"};

/***/ }),

/***/ "SPD/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"daily_list":"daily_list__34j_N","daily_list_note":"daily_list_note__37Xl4","daily_list_row":"daily_list_row__RM2jy","daily_list_head":"daily_list_head__1gpnI","daily_list_date_column":"daily_list_date_column__2RKGl","daily_list_temp_column":"daily_list_temp_column__1UK5V","daily_list_gust_column":"daily_list_gust_column__1HDcM","daily_list_rain_column":"daily_list_rain_column__2666I","daily_list_wind_cell":"daily_list_wind_cell__3jBj7","daily_list_rain_cell":"daily_list_rain_cell__2WJ82","daily_list_raindrop":"daily_list_raindrop__3SvL4","daily_list_temp_cell":"daily_list_temp_cell__1nYEa","daily_list_temp_bar_low":"daily_list_temp_bar_low__2ZHa1","daily_list_temp_bar_high":"daily_list_temp_bar_high__2ewl-","daily_list_temp_label_low":"daily_list_temp_label_low__zoupP","daily_list_temp_label_high":"daily_list_temp_label_high__1b5EF","daily_list_wind_gust_cell":"daily_list_wind_gust_cell__2drxD","daily_list_wind_gust_dir":"daily_list_wind_gust_dir__2l5N5","daily_list_wind_gust_value":"daily_list_wind_gust_value__egOEV","daily_list_circular_cell":"daily_list_circular_cell__1PPg2"};

/***/ }),

/***/ "dFtm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"shrink_unit":"shrink_unit__1dW3v","extreme_value":"extreme_value__3ovCb","data_line":"data_line__aj3p2","data_label":"data_label__37OXM","data_value":"data_value__1B_et","temperature_current":"temperature_current__2o2NN","temperature_high":"temperature_high__3GyOQ","temperature_low":"temperature_low__1cFRA","thermometer":"thermometer__3jQlM","temperature_trend":"temperature_trend__2KN_C","temperature_trend_arrow":"temperature_trend_arrow__3wnbi","temperature_main":"temperature_main__1PYkP","thermometer_wrapper":"thermometer_wrapper__1It4T","humidity_dewpoint":"humidity_dewpoint__2wApX","temperature_extremes":"temperature_extremes__3QPjE","wind_layout":"wind_layout__3cjIx","wind_gauge_wrapper":"wind_gauge_wrapper__tetwi","wind_direction_speed":"wind_direction_speed__1w5ak","wind_gust_high":"wind_gust_high__3xvq8","rain_layout":"rain_layout__2u7-b","rain_rate":"rain_rate__1NbX_","rain_hourly_daily":"rain_hourly_daily__Ip812","rain_month_year":"rain_month_year__3IPMN","pressure":"pressure__3Ieri","rain_section_left":"rain_section_left__10cQw","rain_section_right":"rain_section_right__2c-Rm"};

/***/ }),

/***/ "esRP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_formatters__ = __webpack_require__("gNwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__message_message__ = __webpack_require__("A/Ka");




/**
 * The StaleDataMessage component displays an informational message that the data
 * being displayed on a particular view is stale.
 *
 * props:
 * - freshness: data age (seconds)
 * - timestamp: formatted timestamp of the last update (nz time)
 */
var StaleDataMessage = function StaleDataMessage(props) {

	var period = void 0;
	var periodUnit = void 0;

	if (props.freshness < 3600 * 48) {
		period = Math.floor(props.freshness / 3600);
		periodUnit = 'hour';
	} else {
		period = Math.floor(props.freshness / 86400);
		periodUnit = 'day';
	}

	var lastUpdate = Object(__WEBPACK_IMPORTED_MODULE_1__utils_formatters__["j" /* getDateTimeFormatConverter */])('%Y-%m-%d %H:%M:%S', '%-I:%M %p %-d %b %Y')(props.timestamp);

	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		__WEBPACK_IMPORTED_MODULE_2__message_message__["a" /* default */],
		{ level: 'info' },
		'Data has not updated since ',
		lastUpdate,
		' (',
		period + ' ' + periodUnit + (period > 1 ? 's' : ''),
		' ago).'
	);
};

/* harmony default export */ __webpack_exports__["a"] = (StaleDataMessage);

/***/ }),

/***/ "f5I/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bulb_gradient_stop_1":"bulb_gradient_stop_1__3u2PO","bulb_gradient_stop_2":"bulb_gradient_stop_2__1OO8-","thermometer_max_label":"thermometer_max_label__3QGIS","thermometer_min_label":"thermometer_min_label__1Kow6","thermometer_outline":"thermometer_outline__3RDl5","thermometer_empty":"thermometer_empty__1c6YT","thermometer_extremes":"thermometer_extremes__2RUA0","thermometer_mercury":"thermometer_mercury__2twN_","thermometer_scale":"thermometer_scale__10Z54"};

/***/ }),

/***/ "hS0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./components/daily-summary/index.js
var daily_summary = __webpack_require__("MB83");

// EXTERNAL MODULE: ./components/card/index.js
var card = __webpack_require__("MTo3");

// EXTERNAL MODULE: ./utils/api.js
var api = __webpack_require__("/R+W");

// CONCATENATED MODULE: ./utils/live-data.js
var extractDailyExtremes = function extractDailyExtremes(liveData) {
	return {
		date: liveData.date,
		highTemperature: liveData.temperature.high.value,
		highTemperatureTime: liveData.temperature.high.time,
		lowTemperature: liveData.temperature.low.value,
		lowTemperatureTime: liveData.temperature.low.time,
		avgTemperature: liveData.temperature.mean,
		highWindGust: liveData.wind.gust.high.value,
		highWindGustTime: liveData.wind.gust.high.time,
		highWindGustBearing: liveData.wind.gust.high.bearing,
		highWindSpeed: liveData.wind.speed.high.value,
		highWindSpeedTime: liveData.wind.speed.high.time,
		windRun: liveData.wind.runToday,
		rainfall: liveData.rainfall.totalToday,
		highRainRate: liveData.rainfall.rate.high.value,
		highRainRateTime: liveData.rainfall.rate.high.time,
		highHourlyRain: liveData.rainfall.hourly.high.value,
		highHourlyRainTime: liveData.rainfall.hourly.high.time,
		highDewpoint: liveData.dewpoint.high.value,
		highDewpointTime: liveData.dewpoint.high.time,
		lowDewpoint: liveData.dewpoint.low.value,
		lowDewpointTime: liveData.dewpoint.low.time,
		highHumidity: liveData.humidity.high.value,
		highHumidityTime: liveData.humidity.high.time,
		lowHumidity: liveData.humidity.low.value,
		lowHumidityTime: liveData.humidity.low.time,
		highPressure: liveData.pressure.high.value,
		highPressureTime: liveData.pressure.high.time,
		lowPressure: liveData.pressure.low.value,
		lowPressureTime: liveData.pressure.low.time
	};
};

var extractTemperatureSummaryData = function extractTemperatureSummaryData(liveData) {
	return {
		currentTemperature: liveData.temperature.current,
		temperatureTrend: liveData.temperature.changeLastHour,
		currentDewpoint: liveData.dewpoint.current,
		currentHumidity: liveData.humidity.current,
		highTemperature: liveData.temperature.high.value,
		highTemperatureTime: liveData.temperature.high.time,
		lowTemperature: liveData.temperature.low.value,
		lowTemperatureTime: liveData.temperature.low.time
	};
};

var extractWindSummaryData = function extractWindSummaryData(liveData) {
	return {
		liveWindSpeed: liveData.wind.speed.live,
		liveWindBearing: liveData.wind.bearing.live,
		meanWindSpeed: liveData.wind.speed.mean,
		meanWindBearing: liveData.wind.bearing.mean,
		currentWindGust: liveData.wind.gust.current,
		highWindGust: liveData.wind.gust.high.value,
		highWindGustTime: liveData.wind.gust.high.time,
		highWindGustBearing: liveData.wind.gust.high.bearing
	};
};

var extractRainSummaryData = function extractRainSummaryData(liveData) {
	return {
		currentRainRate: liveData.rainfall.rate.current,
		currentConditions: liveData.rainfall.rate.description,
		currentHourlyRain: liveData.rainfall.hourly.current,
		rainToday: liveData.rainfall.totalToday,
		rainThisMonth: liveData.rainfall.totalThisMonth,
		rainThisYear: liveData.rainfall.totalThisYear,
		currentPressure: liveData.pressure.current,
		pressureTrend: liveData.pressure.changeLastHour
	};
};
// EXTERNAL MODULE: ./components/live-updated-time/style.scss
var style = __webpack_require__("76Ws");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./routes/live/reducers.js
var OBSERVATIONS_VIEW = {
	HOURLY: 'hourly',
	DAILY: 'daily'
};

var LIVE_UPDATE_STATUS = {
	UNCHANGED: 0,
	UPDATED: 1,
	ERROR: 2,
	NONE: 3
};

var initialState = function initialState() {
	return {
		liveData: undefined,
		freshness: 0,
		liveDataLoading: false,
		liveDataRetryCount: -1,
		liveUpdatesPaused: false,
		liveDataLoadTime: null,
		lastUpdateStatus: null,

		liveTemperature: [],
		liveWindSpeed: [],
		liveRainRate: [],

		yesterdayExtremes: undefined,
		yesterdayExtremesLoading: false,
		yesterdayExtremesRetryCount: -1,

		hourlyObservations: undefined,
		hourlyObservationsLoading: false,
		hourlyObservationsRetryCount: -1,

		dailyObservations: undefined,
		dailyObservationsLoading: false,
		dailyObservationsRetryCount: -1,

		activeObservationsView: OBSERVATIONS_VIEW.HOURLY
	};
};

var pauseLiveUpdates = function pauseLiveUpdates() {
	return {
		liveUpdatesPaused: true
	};
};

var resumeLiveUpdates = function resumeLiveUpdates() {
	return {
		liveUpdatesPaused: false
	};
};

var liveDataLoading = function liveDataLoading() {
	return {
		liveDataLoading: true
	};
};

var liveDataLoadSuccess = function liveDataLoadSuccess(data) {

	var update = {
		liveDataLoading: false,
		liveDataRetryCount: -1,
		lastUpdateStatus: data === null ? LIVE_UPDATE_STATUS.UNCHANGED : LIVE_UPDATE_STATUS.UPDATED,
		liveDataLoadTime: new Date().getTime()
	};

	if (data !== null) {
		update.liveData = data.data;
		update.freshness = data.freshness;
	}

	return update;
};

var liveDataLoadFailure = function liveDataLoadFailure(state) {

	var update = {
		liveDataLoading: false,
		liveDataRetryCount: state.liveDataRetryCount + 1,
		lastUpdateStatus: LIVE_UPDATE_STATUS.ERROR,
		liveDataLoadTime: new Date().getTime()
	};

	// Only null the data if none has been received successfully prior.
	if (state.liveData === undefined) {
		update.liveData = null;
	}

	return update;
};

var todayHistoryLoading = function todayHistoryLoading() {
	return {
		todayHistoryLoading: true
	};
};

var todayHistoryLoadSuccess = function todayHistoryLoadSuccess(data) {
	return {
		todayHistoryLoading: false,
		todayHistoryRetryCount: -1,
		todayHistory: data
	};
};

var todayHistoryLoadFailure = function todayHistoryLoadFailure(state) {
	return {
		todayHistoryLoading: false,
		todayHistoryRetryCount: state.todayHistoryRetryCount + 1,
		todayHistory: null
	};
};

var yesterdayExtremesLoading = function yesterdayExtremesLoading() {
	return {
		yesterdayExtremesLoading: true
	};
};

var yesterdayExtremesLoadSuccess = function yesterdayExtremesLoadSuccess(data) {
	return {
		yesterdayExtremesLoading: false,
		yesterdayExtremesRetryCount: -1,
		yesterdayExtremes: data
	};
};

var yesterdayExtremesLoadFailure = function yesterdayExtremesLoadFailure(state) {
	return {
		yesterdayExtremesLoading: false,
		yesterdayExtremesRetryCount: state.yesterdayExtremesRetryCount + 1,
		yesterdayExtremes: null
	};
};

var hourlyObservationsLoading = function hourlyObservationsLoading() {
	return {
		hourlyObservationsLoading: true
	};
};

var hourlyObservationsLoadSuccess = function hourlyObservationsLoadSuccess(data) {
	return {
		hourlyObservationsLoading: false,
		hourlyObservationsRetryCount: -1,
		hourlyObservations: data
	};
};

var hourlyObservationsLoadFailure = function hourlyObservationsLoadFailure(state) {

	var update = {
		hourlyObservationsLoading: false,
		hourlyObservationsRetryCount: state.hourlyObservationsRetryCount + 1
	};

	// Only null the data if none has been received successfully prior.
	if (state.hourlyObservations === undefined) {
		update.hourlyObservations = null;
	}

	return update;
};

var dailyObservationsLoading = function dailyObservationsLoading() {
	return {
		dailyObservationsLoading: true
	};
};

var dailyObservationsLoadSuccess = function dailyObservationsLoadSuccess(data) {
	return {
		dailyObservationsLoading: false,
		dailyObservationsRetryCount: -1,
		dailyObservations: data
	};
};

var dailyObservationsLoadFailure = function dailyObservationsLoadFailure(state) {

	var update = {
		dailyObservationsLoading: false,
		dailyObservationsRetryCount: state.dailyObservationsRetryCount + 1
	};

	// Only null the data if none has been received successfully prior.
	if (state.dailyObservations === undefined) {
		update.dailyObservations = null;
	}

	return update;
};

var reducers_switchObservationsView = function switchObservationsView(view) {
	return {
		activeObservationsView: view
	};
};
// EXTERNAL MODULE: ./utils/formatters.js
var formatters = __webpack_require__("gNwm");

// CONCATENATED MODULE: ./components/live-updated-time/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The LiveUpdatedTime component displays a date and timestamp when the live data
 * was last updated. It includes a flash of highlight colour on the timestamp
 * every time it changes.
 *
 * props:
 * - date: current date, pre-formatted
 * - time: current timestamp, pre-formatted
 * - isPaused: are live updates currently paused
 * - resume: callback for when resume is clicked
 */

var live_updated_time_LiveUpdatedTime = function (_Component) {
	_inherits(LiveUpdatedTime, _Component);

	function LiveUpdatedTime(props) {
		_classCallCheck(this, LiveUpdatedTime);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.BEACON_STATE = {
			INACTIVE: 0,
			SUCCESS: 1,
			ERROR: 2,
			STALE: 3
		};

		_this.state = {
			isHighlighted: false,
			beaconState: _this.BEACON_STATE.INACTIVE
		};

		_this.formatters = {
			date: Object(formatters["j" /* getDateTimeFormatConverter */])('%Y-%m-%d', '%a %-d %b %Y'),
			time: Object(formatters["j" /* getDateTimeFormatConverter */])('%H:%M:%S', '%-I:%M:%S %p')
		};
		return _this;
	}

	LiveUpdatedTime.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		var _this2 = this;

		if (this.props.liveDataLoadTime !== nextProps.liveDataLoadTime) {

			var beaconState = void 0;

			switch (nextProps.lastUpdateStatus) {
				case LIVE_UPDATE_STATUS.UPDATED:
					beaconState = this.BEACON_STATE.SUCCESS;
					break;
				case LIVE_UPDATE_STATUS.ERROR:
					beaconState = this.BEACON_STATE.ERROR;
					break;
				case LIVE_UPDATE_STATUS.UNCHANGED:
					beaconState = this.BEACON_STATE.STALE;
					break;
				default:
					beaconState = this.BEACON_STATE.INACTIVE;
			}

			this.setState({ beaconState: beaconState });

			this.beaconTimer = setTimeout(function () {
				_this2.setState({ beaconState: _this2.BEACON_STATE.INACTIVE });
			}, 500);
		}
	};

	LiveUpdatedTime.prototype.componentWillUnmount = function componentWillUnmount() {
		clearTimeout(this.beaconTimer);
	};

	LiveUpdatedTime.prototype.renderPaused = function renderPaused() {
		return Object(preact_min["h"])(
			'div',
			{ 'class': style_default.a.updated_at_paused },
			'PAUSED -',
			Object(preact_min["h"])(
				'button',
				{ onClick: this.props.resume },
				'click to resume'
			)
		);
	};

	LiveUpdatedTime.prototype.render = function render(props) {

		var beaconClasses = [style_default.a.beacon];

		switch (this.state.beaconState) {
			case this.BEACON_STATE.SUCCESS:
				beaconClasses.push(style_default.a.beacon_success);
				break;
			case this.BEACON_STATE.ERROR:
				beaconClasses.push(style_default.a.beacon_error);
				break;
			case this.BEACON_STATE.STALE:
				beaconClasses.push(style_default.a.beacon_stale);
				break;
		}

		var time = props.time ? this.formatters.time(props.time) + ' ' + this.formatters.date(props.date) : '---';

		return Object(preact_min["h"])(
			'div',
			{ 'class': style_default.a.wrapper },
			Object(preact_min["h"])('div', { 'class': beaconClasses.join(' ') }),
			Object(preact_min["h"])(
				'div',
				{ 'class': style_default.a.updated_at },
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.updated_at_main },
					'Updated: ',
					time
				),
				props.isPaused ? this.renderPaused() : null
			)
		);
	};

	return LiveUpdatedTime;
}(preact_min["Component"]);

/* harmony default export */ var live_updated_time = (live_updated_time_LiveUpdatedTime);
// EXTERNAL MODULE: ./components/loader/index.js
var loader = __webpack_require__("Cvo2");

// EXTERNAL MODULE: ../node_modules/d3-scale/src/index.js + 38 modules
var src = __webpack_require__("zL2z");

// EXTERNAL MODULE: ../node_modules/d3-array/src/index.js + 31 modules
var d3_array_src = __webpack_require__("K0bd");

// EXTERNAL MODULE: ../node_modules/d3-axis/src/index.js + 3 modules
var d3_axis_src = __webpack_require__("mp0m");

// EXTERNAL MODULE: ../node_modules/d3-selection/src/index.js + 50 modules
var d3_selection_src = __webpack_require__("//ys");

// EXTERNAL MODULE: ./components/thermometer/style.scss
var thermometer_style = __webpack_require__("f5I/");
var thermometer_style_default = /*#__PURE__*/__webpack_require__.n(thermometer_style);

// CONCATENATED MODULE: ./components/thermometer/index.js


function thermometer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function thermometer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function thermometer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 * The Thermometer component renders an SVG thermometer.
 *
 * props:
 * - minValue: thermometer minimum value
 * - maxValue: thermometer maximum value
 * - currentValue: thermometer current value
 */

var thermometer_Thermometer = function (_Component) {
	thermometer__inherits(Thermometer, _Component);

	function Thermometer(props) {
		thermometer__classCallCheck(this, Thermometer);

		var _this = thermometer__possibleConstructorReturn(this, _Component.call(this, props));

		_this.width = 80;
		_this.height = 160;
		_this.tubeWidth = 18.5;
		_this.margin = 5;
		_this.bulbRadius = 18;
		return _this;
	}

	Thermometer.prototype.render = function render(props) {
		this.initAxis(props);

		return Object(preact_min["h"])(
			'svg',
			{ viewBox: '0 0 ' + this.width + ' ' + this.height },
			Object(preact_min["h"])(
				'defs',
				null,
				Object(preact_min["h"])(
					'radialGradient',
					{ id: 'bulb-gradient', cx: '50%', cy: '50%', r: '50%', fx: '50%', fy: '50%' },
					Object(preact_min["h"])('stop', { offset: '0%', 'class': thermometer_style_default.a.bulb_gradient_stop_1 }),
					Object(preact_min["h"])('stop', { offset: '80%', 'class': thermometer_style_default.a.bulb_gradient_stop_2 })
				)
			),
			Object(preact_min["h"])(
				'g',
				{ 'stroke-width': '1px', transform: 'translate(' + 0.5 * this.width + ',0)' },
				this.renderTube(),
				this.renderExtremes(props),
				this.renderMercury(props),
				this.renderScale()
			)
		);
	};

	Thermometer.prototype.renderTube = function renderTube() {
		return Object(preact_min["h"])(
			'g',
			null,
			Object(preact_min["h"])('circle', { 'class': thermometer_style_default.a.thermometer_outline,
				r: 0.5 * this.tubeWidth,
				cx: 0,
				cy: this.margin + 0.5 * this.tubeWidth
			}),
			Object(preact_min["h"])('rect', { 'class': thermometer_style_default.a.thermometer_outline,
				x: -0.5 * this.tubeWidth,
				y: this.margin + 0.5 * this.tubeWidth,
				width: this.tubeWidth,
				height: this.height - 2 * this.bulbRadius
			}),
			Object(preact_min["h"])('circle', { 'class': thermometer_style_default.a.thermometer_empty,
				r: 0.5 * this.tubeWidth - 0.5,
				cx: 0,
				cy: this.margin + 0.5 * this.tubeWidth
			}),
			Object(preact_min["h"])('circle', { 'class': thermometer_style_default.a.thermometer_outline,
				r: this.bulbRadius,
				cx: 0,
				cy: this.height - this.margin - this.bulbRadius
			}),
			Object(preact_min["h"])('rect', { 'class': thermometer_style_default.a.thermometer_empty,
				x: -0.5 * this.tubeWidth + 0.5,
				y: this.margin + 0.5 * this.tubeWidth,
				width: this.tubeWidth - 1,
				height: this.height - 2 * this.bulbRadius
			})
		);
	};

	Thermometer.prototype.renderExtremes = function renderExtremes(props) {
		return Object(preact_min["h"])(
			'g',
			{ 'class': thermometer_style_default.a.thermometer_extremes },
			Object(preact_min["h"])('line', { x1: -0.5 * this.tubeWidth,
				x2: 0.5 * this.tubeWidth + 22,
				y1: this.axisScale(props.minValue),
				y2: this.axisScale(props.minValue)
			}),
			Object(preact_min["h"])('line', { x1: -0.5 * this.tubeWidth,
				x2: 0.5 * this.tubeWidth + 22,
				y1: this.axisScale(props.maxValue),
				y2: this.axisScale(props.maxValue)
			}),
			Object(preact_min["h"])(
				'text',
				{ 'class': thermometer_style_default.a.thermometer_max_label,
					x: 0.5 * this.tubeWidth + 2,
					y: this.axisScale(props.maxValue),
					dy: '-0.35em'
				},
				'max'
			),
			Object(preact_min["h"])(
				'text',
				{ 'class': thermometer_style_default.a.thermometer_min_label,
					x: 0.5 * this.tubeWidth + 2,
					y: this.axisScale(props.minValue),
					dy: '1em'
				},
				'min'
			)
		);
	};

	Thermometer.prototype.renderMercury = function renderMercury(props) {
		var y = this.axisScale(props.currentValue);

		return Object(preact_min["h"])(
			'g',
			{ 'class': thermometer_style_default.a.thermometer_mercury },
			Object(preact_min["h"])('rect', { x: -0.5 * this.tubeWidth + 4,
				y: y,
				width: this.tubeWidth - 8,
				height: this.height - this.margin - this.bulbRadius - y
			}),
			Object(preact_min["h"])('circle', { cx: 0,
				cy: this.height - this.margin - this.bulbRadius,
				r: this.bulbRadius - 4,
				fill: 'url(#bulb-gradient)'
			})
		);
	};

	Thermometer.prototype.renderScale = function renderScale() {
		var _this2 = this;

		// Values to use along the scale ticks up the thermometer
		var axisTickValues = Object(d3_array_src["range"])((this.axisDomain[1] - this.axisDomain[0]) / this.axisStep + 1).map(function (v) {
			return _this2.axisDomain[0] + v * _this2.axisStep;
		});

		var axis = Object(d3_axis_src["axisLeft"])().scale(this.axisScale).tickSizeInner(7).tickSizeOuter(0).tickValues(axisTickValues);

		return Object(preact_min["h"])('g', { 'class': thermometer_style_default.a.thermometer_scale,
			transform: 'translate(' + -0.5 * this.tubeWidth + ',0)',
			ref: function ref(elem) {
				return Object(d3_selection_src["select"])(elem).call(axis);
			}
		});
	};

	Thermometer.prototype.initAxis = function initAxis(props) {
		this.axisStep = 5;

		// Determine a suitable range of the temperature scale
		this.axisDomain = [this.axisStep * Math.floor(props.minValue / this.axisStep), this.axisStep * Math.ceil(props.maxValue / this.axisStep)];

		if (props.minValue - this.axisDomain[0] < 0.66 * this.axisStep) {
			this.axisDomain[0] -= this.axisStep;
		}

		if (this.axisDomain[1] - props.maxValue < 0.66 * this.axisStep) {
			this.axisDomain[1] += this.axisStep;
		}

		this.axisScale = Object(src["scaleLinear"])().domain(this.axisDomain).range([this.height - this.margin - 2 * this.bulbRadius, this.margin + 0.5 * this.tubeWidth]);
	};

	return Thermometer;
}(preact_min["Component"]);

/* harmony default export */ var thermometer = (thermometer_Thermometer);
// EXTERNAL MODULE: ./components/live/style.scss
var live_style = __webpack_require__("dFtm");
var live_style_default = /*#__PURE__*/__webpack_require__.n(live_style);

// CONCATENATED MODULE: ./components/live/data-line.js



/**
 * The DataLine component is a small helper component for displaying
 * a line of data in the primary live data view on the home page.
 *
 * props:
 * - label: The label for this piece of data
 * - value: The data value
 * - unit: The unit associated with this piece of data (formatted for display)
 */

var data_line_DataLine = function DataLine(props) {
  return Object(preact_min["h"])(
    'div',
    { 'class': live_style_default.a.data_line },
    Object(preact_min["h"])(
      'span',
      { 'class': live_style_default.a.data_label },
      props.label,
      ':'
    ),
    Object(preact_min["h"])(
      'span',
      { 'class': live_style_default.a.data_value },
      props.value,
      Object(preact_min["h"])(
        'span',
        { 'class': live_style_default.a.shrink_unit },
        props.unit
      )
    )
  );
};

/* harmony default export */ var data_line = (data_line_DataLine);
// EXTERNAL MODULE: ./utils/interpolators.js
var interpolators = __webpack_require__("VqWv");

// EXTERNAL MODULE: ./utils/unit-converters.js
var unit_converters = __webpack_require__("rbCG");

// CONCATENATED MODULE: ./components/live/temperature-summary.js


function temperature_summary__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function temperature_summary__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function temperature_summary__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











/**
 * The TemperatureSummary component is displayed on the home page as part of the primary live
 * data view. It displays live temperature information.
 *
 * props:
 * - data: A data model object containing the data needed for the view
 * - temperatureUnit: The current temperature unit
 * - temperatureFormatter: A function for formatting temperature values for display purposes
 * - temperatureTrendFormatter: A function for formatting the temperature trend value for display purposes
 * - timeFormatter: A function for formatting timestamps for display purposes
 */

var _ref = Object(preact_min["h"])(
	card["a" /* default */],
	null,
	Object(preact_min["h"])(loader["a" /* default */], null)
);

var _ref2 = Object(preact_min["h"])(
	'div',
	null,
	'High'
);

var _ref3 = Object(preact_min["h"])(
	'div',
	null,
	'Low'
);

var temperature_summary_TemperatureSummary = function (_Component) {
	temperature_summary__inherits(TemperatureSummary, _Component);

	function TemperatureSummary(props) {
		temperature_summary__classCallCheck(this, TemperatureSummary);

		var _this = temperature_summary__possibleConstructorReturn(this, _Component.call(this, props));

		_this.temperatureInterpolator = Object(interpolators["b" /* getTemperatureColourInterpolator */])(true);
		return _this;
	}

	TemperatureSummary.prototype.render = function render(props) {
		var data = props.data,
		    temperatureUnit = props.temperatureUnit,
		    temperatureFormatter = props.temperatureFormatter,
		    temperatureTrendFormatter = props.temperatureTrendFormatter,
		    timeFormatter = props.timeFormatter;


		if (!data) {
			return _ref;
		}

		var tempStyle = {
			borderBottomColor: this.temperatureInterpolator(data.currentTemperature, temperatureUnit)
		};

		var temperatureTrendArrow = null;

		if (data.temperatureTrend !== 0) {
			var arrow = data.temperatureTrend > 0 ? '\u2191' : '\u2193';
			temperatureTrendArrow = Object(preact_min["h"])(
				'span',
				{ 'class': live_style_default.a.temperature_trend_arrow },
				arrow
			);
		}

		return Object(preact_min["h"])(
			card["a" /* default */],
			null,
			Object(preact_min["h"])(
				'div',
				{ 'class': live_style_default.a.temperature_main },
				Object(preact_min["h"])(
					'div',
					{ 'class': live_style_default.a.temperature_current, style: tempStyle },
					temperatureFormatter(data.currentTemperature),
					Object(preact_min["h"])(
						'span',
						{ 'class': live_style_default.a.shrink_unit },
						'\xB0',
						temperatureUnit
					)
				),
				Object(preact_min["h"])(
					'div',
					null,
					Object(preact_min["h"])(
						'span',
						{ 'class': live_style_default.a.data_line },
						Object(preact_min["h"])(
							'span',
							{ 'class': live_style_default.a.temperature_trend },
							temperatureTrendArrow,
							Object(preact_min["h"])(
								'span',
								{ 'class': live_style_default.a.data_value },
								(data.temperatureTrend >= 0 ? '+' : '') + temperatureTrendFormatter(data.temperatureTrend),
								Object(preact_min["h"])(
									'span',
									{ 'class': live_style_default.a.shrink_unit },
									'\xB0',
									temperatureUnit,
									'/hr'
								)
							)
						)
					)
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': live_style_default.a.thermometer_wrapper },
				Object(preact_min["h"])(
					'div',
					{ 'class': live_style_default.a.thermometer },
					Object(preact_min["h"])(thermometer, { currentValue: Object(unit_converters["c" /* convertTemperature */])(data.currentTemperature, temperatureUnit),
						minValue: Object(unit_converters["c" /* convertTemperature */])(data.lowTemperature, temperatureUnit),
						maxValue: Object(unit_converters["c" /* convertTemperature */])(data.highTemperature, temperatureUnit) })
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': live_style_default.a.temperature_extremes },
					Object(preact_min["h"])(
						'div',
						{ 'class': live_style_default.a.temperature_high },
						_ref2,
						Object(preact_min["h"])(
							'div',
							{ 'class': live_style_default.a.extreme_value },
							Object(preact_min["h"])(
								'span',
								null,
								temperatureFormatter(data.highTemperature)
							),
							Object(preact_min["h"])(
								'span',
								{ 'class': live_style_default.a.shrink_unit },
								'\xB0',
								temperatureUnit
							)
						),
						Object(preact_min["h"])(
							'div',
							null,
							timeFormatter(data.highTemperatureTime)
						)
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': live_style_default.a.temperature_low },
						_ref3,
						Object(preact_min["h"])(
							'div',
							{ 'class': live_style_default.a.extreme_value },
							Object(preact_min["h"])(
								'span',
								null,
								temperatureFormatter(data.lowTemperature)
							),
							Object(preact_min["h"])(
								'span',
								{ 'class': live_style_default.a.shrink_unit },
								'\xB0',
								temperatureUnit
							)
						),
						Object(preact_min["h"])(
							'div',
							null,
							timeFormatter(data.lowTemperatureTime)
						)
					)
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': live_style_default.a.humidity_dewpoint },
				Object(preact_min["h"])(data_line, { label: 'Humidity', value: data.currentHumidity, unit: '%' }),
				Object(preact_min["h"])(data_line, { label: 'Dewpoint', value: temperatureFormatter(data.currentDewpoint), unit: '\xB0' + temperatureUnit })
			)
		);
	};

	return TemperatureSummary;
}(preact_min["Component"]);

/* harmony default export */ var temperature_summary = (temperature_summary_TemperatureSummary);
// EXTERNAL MODULE: ./components/wind-gauge/style.scss
var wind_gauge_style = __webpack_require__("wPJI");
var wind_gauge_style_default = /*#__PURE__*/__webpack_require__.n(wind_gauge_style);

// CONCATENATED MODULE: ./components/wind-gauge/index.js


function wind_gauge__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function wind_gauge__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function wind_gauge__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The WindGauge component render a live wind speed gauge, which animates
 * the direction indicator as it moves around the compass.
 *
 * props:
 * - size: The width/height of the SVG
 * - windSpeed: Live wind speed value. May be a number or pre-formatted string.
 * - windBearing: Live wind bearing (numeric).
 */

var wind_gauge_WindGauge = function (_Component) {
	wind_gauge__inherits(WindGauge, _Component);

	function WindGauge(props) {
		wind_gauge__classCallCheck(this, WindGauge);

		var _this = wind_gauge__possibleConstructorReturn(this, _Component.call(this, props));

		_this.previousBearing = null;

		// Check if the browser supports the <animateTransform> element. For browsers that do,
		// we will animate the wind arrow rotation angle. If not we will fall back to no animation at all.
		_this.browserSupportsAnimateTransform = !!document.createElementNS('http://www.w3.org/2000/svg', 'animateTransform').beginElement;
		return _this;
	}

	WindGauge.prototype.componentDidUpdate = function componentDidUpdate() {
		if (this.browserSupportsAnimateTransform) {
			this.animateTransformElement.beginElement();
		}
	};

	WindGauge.prototype.render = function render(props) {
		var _this2 = this;

		var size = props.size,
		    windSpeed = props.windSpeed,
		    windBearing = props.windBearing;

		var halfSize = 0.5 * size;
		var margin = 20;
		var labelSpacing = 9.5;
		var radius = halfSize - margin;

		// Define the direction indicator path
		var indicatorSize = 20;
		var indicatorY0 = halfSize - radius + 0.5 * indicatorSize + 3;
		var indicatorY1 = indicatorY0 - indicatorSize;
		var indicatorX0 = halfSize - indicatorSize * 0.4;
		var indicatorX1 = halfSize + indicatorSize * 0.4;

		var indicatorPath = 'M' + indicatorX0 + ',' + indicatorY1 + ' L' + indicatorX1 + ',' + indicatorY1 + ' L' + halfSize + ',' + indicatorY0 + ' L' + indicatorX0 + ',' + indicatorY1;

		// Angle to rotate the indicator to and from
		var rotateFromAngle = this.previousBearing === null ? windBearing : this.previousBearing;
		var rotateToAngle = windBearing;

		// We are working with a circular range. So when rotating from 350 deg to 10 deg, the natural
		// animation is to rotate through the 0 deg point (N), not all the way around the compass through S.
		if (rotateFromAngle - rotateToAngle > 180) {
			rotateToAngle += 360;
		} else if (rotateFromAngle - rotateToAngle < -180) {
			rotateToAngle -= 360;
		}

		var rotateFrom = rotateFromAngle + ' ' + halfSize + ' ' + halfSize;

		// Angle to rotate the indicator to
		var rotateTo = rotateToAngle + ' ' + halfSize + ' ' + halfSize;

		this.previousBearing = windBearing;

		var isCalm = Number(windSpeed) === 0;

		return Object(preact_min["h"])(
			'svg',
			{ width: size, height: size },
			Object(preact_min["h"])(
				'g',
				{ 'class': wind_gauge_style_default.a.direction_labels },
				Object(preact_min["h"])(
					'text',
					{ x: halfSize,
						y: margin - labelSpacing,
						'text-anchor': 'middle' },
					'N'
				),
				Object(preact_min["h"])(
					'text',
					{ x: size - margin + labelSpacing,
						y: halfSize,
						'text-anchor': 'start',
						dy: '0.35em' },
					'E'
				),
				Object(preact_min["h"])(
					'text',
					{ x: halfSize,
						y: halfSize + radius + labelSpacing,
						'text-anchor': 'middle',
						dy: '0.71em' },
					'S'
				),
				Object(preact_min["h"])(
					'text',
					{ x: margin - labelSpacing,
						y: halfSize,
						'text-anchor': 'end',
						dy: '0.35em' },
					'W'
				)
			),
			Object(preact_min["h"])('circle', { 'class': wind_gauge_style_default.a.outline,
				cx: halfSize,
				cy: halfSize,
				r: radius }),
			Object(preact_min["h"])(
				'text',
				{ 'class': wind_gauge_style_default.a.current_speed,
					x: halfSize,
					y: halfSize,
					'text-anchor': 'middle',
					dy: '0.35em' },
				windSpeed
			),
			Object(preact_min["h"])(
				'g',
				{ style: { fillOpacity: isCalm ? 0 : 1, strokeOpacity: isCalm ? 0 : 1 } },
				Object(preact_min["h"])(
					'path',
					{ 'class': wind_gauge_style_default.a.direction_arrow,
						d: indicatorPath,
						transform: 'rotate(' + rotateTo + ')' },
					this.browserSupportsAnimateTransform ? Object(preact_min["h"])('animateTransform', { ref: function ref(el) {
							_this2.animateTransformElement = el;
						},
						attributeType: 'XML',
						attributeName: 'transform',
						type: 'rotate',
						begin: '0s',
						dur: '0.5s',
						from: rotateFrom,
						to: rotateTo,
						fill: 'freeze' }) : null
				)
			)
		);
	};

	return WindGauge;
}(preact_min["Component"]);

/* harmony default export */ var wind_gauge = (wind_gauge_WindGauge);
// EXTERNAL MODULE: ./utils/convert-wind-bearing.js
var convert_wind_bearing = __webpack_require__("Dqzv");

// CONCATENATED MODULE: ./components/live/wind-summary.js








/**
 * The WindSummary component is displayed on the home page as part of the primary live
 * data view. It displays live wind direction and speed information.
 *
 * props:
 * - data: A data model object containing the data needed for the view
 * - speedUnit: The current wind speed unit
 * - windSpeedFormatter: A function for formatting mean wind speed values for display purposes
 * - windGustFormatter: A function for formatting wind gust values for display purposes
 * - timeFormatter: A function for formatting timestamps for display purposes
 */

var wind_summary__ref = Object(preact_min["h"])(
	card["a" /* default */],
	null,
	Object(preact_min["h"])(loader["a" /* default */], null)
);

var wind_summary__ref2 = Object(preact_min["h"])(
	'div',
	null,
	'Max Gust'
);

var wind_summary_WindSummary = function WindSummary(props) {
	var data = props.data,
	    windSpeedFormatter = props.windSpeedFormatter,
	    windGustFormatter = props.windGustFormatter,
	    timeFormatter = props.timeFormatter,
	    speedUnit = props.speedUnit;


	if (!data) {
		return wind_summary__ref;
	}

	var liveSpeed = windGustFormatter(data.liveWindSpeed);

	var direction = data.currentWindGust === 0 ? 'Calm' : Object(convert_wind_bearing["a" /* convertWindBearing16 */])(data.meanWindBearing) + (' (' + data.meanWindBearing + '\xB0)');

	return Object(preact_min["h"])(
		card["a" /* default */],
		null,
		Object(preact_min["h"])(
			'div',
			{ 'class': live_style_default.a.wind_layout },
			Object(preact_min["h"])(
				'div',
				{ 'class': live_style_default.a.wind_gauge_wrapper },
				Object(preact_min["h"])(wind_gauge, { size: 130, windSpeed: liveSpeed, windBearing: data.liveWindBearing })
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': live_style_default.a.wind_direction_speed },
				Object(preact_min["h"])(data_line, { label: 'Direction', value: direction }),
				Object(preact_min["h"])(data_line, { label: 'Avg speed', value: windSpeedFormatter(data.meanWindSpeed, speedUnit), unit: ' ' + speedUnit }),
				Object(preact_min["h"])(data_line, { label: 'Gusting to', value: windGustFormatter(data.currentWindGust, speedUnit), unit: ' ' + speedUnit })
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': live_style_default.a.wind_gust_high },
				wind_summary__ref2,
				Object(preact_min["h"])(
					'div',
					{ 'class': live_style_default.a.extreme_value },
					data.highWindGust > 0 ? Object(preact_min["h"])(
						'span',
						{ 'class': live_style_default.a.shrink_unit },
						Object(convert_wind_bearing["b" /* convertWindBearing8 */])(data.highWindGustBearing),
						' '
					) : null,
					Object(preact_min["h"])(
						'span',
						null,
						windGustFormatter(data.highWindGust)
					),
					Object(preact_min["h"])(
						'span',
						{ 'class': live_style_default.a.shrink_unit },
						' ',
						speedUnit
					)
				),
				Object(preact_min["h"])(
					'div',
					null,
					timeFormatter(data.highWindGustTime)
				)
			)
		)
	);
};

/* harmony default export */ var wind_summary = (wind_summary_WindSummary);
// EXTERNAL MODULE: ./components/rain-rate-status/style.scss
var rain_rate_status_style = __webpack_require__("jb/y");
var rain_rate_status_style_default = /*#__PURE__*/__webpack_require__.n(rain_rate_status_style);

// CONCATENATED MODULE: ./components/rain-rate-status/index.js



/**
 * The RainRateStatus component displays the current rain rate information
 * on the home page.
 *
 * props:
 * - rainRate: The current rainfall rate
 * - rainUnit: The current rainfall unit
 * - rainRateFormatter: A function used for formatting the rainfall rate for display
 */

var rain_rate_status_RainRateStatus = function RainRateStatus(props) {
	var rainRate = props.rainRate,
	    description = props.description,
	    rainUnit = props.rainUnit,
	    rainRateFormatter = props.rainRateFormatter;


	if (rainRate === 0) {
		return Object(preact_min["h"])(
			'div',
			{ 'class': rain_rate_status_style_default.a.rain_rate_dry },
			description
		);
	}

	var cssClass = void 0;

	switch (description) {
		case 'Light rain/drizzle':
		case 'Light rain':
			cssClass = rain_rate_status_style_default.a.rain_icon_light;
			break;
		case 'Moderate rain':
			cssClass = rain_rate_status_style_default.a.rain_icon_moderate;
			break;
		case 'Heavy rain':
			cssClass = rain_rate_status_style_default.a.rain_icon_heavy;
			break;
		case 'Very heavy rain':
		case 'Torrential rain':
			cssClass = rain_rate_status_style_default.a.rain_icon_very_heavy;
			break;
	}

	return Object(preact_min["h"])(
		'div',
		{ 'class': rain_rate_status_style_default.a.rain_rate_box },
		Object(preact_min["h"])('div', { 'class': cssClass }),
		Object(preact_min["h"])(
			'div',
			{ 'class': rain_rate_status_style_default.a.rain_rate_data },
			Object(preact_min["h"])(
				'div',
				{ 'class': rain_rate_status_style_default.a.rain_rate_descriptor },
				description
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': rain_rate_status_style_default.a.rain_rate_value },
				Object(preact_min["h"])(
					'span',
					null,
					rainRateFormatter(rainRate)
				),
				Object(preact_min["h"])(
					'span',
					{ 'class': rain_rate_status_style_default.a.rain_rate_unit },
					' ',
					rainUnit + '/hr'
				)
			)
		)
	);
};

/* harmony default export */ var rain_rate_status = (rain_rate_status_RainRateStatus);
// CONCATENATED MODULE: ./components/live/rain-summary.js


function rain_summary__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function rain_summary__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function rain_summary__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









/**
 * The RainSummary component is displayed on the home page as part of the primary live
 * data view. It displays live rainfall information (along with atmospheric pressure).
 *
 * props:
 * - data: A data model object containing the data needed for the view
 * - rainUnit: The current rainfall unit
 * - pressureUnit: The current pressure unit
 * - rainFormatter: A function for formatting rainfall values for display purposes
 * - rainRateFormatter: A function for formatting rain rate values for display purposes
 * - pressureFormatter: A function for formatting pressure values for display purposes
 */

var rain_summary__ref = Object(preact_min["h"])(
	card["a" /* default */],
	null,
	Object(preact_min["h"])(loader["a" /* default */], null)
);

var rain_summary_RainSummary = function (_Component) {
	rain_summary__inherits(RainSummary, _Component);

	function RainSummary(props) {
		rain_summary__classCallCheck(this, RainSummary);

		// todo review during live charts implementation
		var _this = rain_summary__possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			liveRainRate: []
		};
		return _this;
	}

	RainSummary.prototype.render = function render(props) {
		var data = props.data,
		    rainUnit = props.rainUnit,
		    pressureUnit = props.pressureUnit,
		    rainFormatter = props.rainFormatter,
		    rainRateFormatter = props.rainRateFormatter,
		    pressureFormatter = props.pressureFormatter;


		if (!data) {
			return rain_summary__ref;
		}

		var pressureTrendPrefix = data.pressureTrend > 0 ? '+' : '';

		return Object(preact_min["h"])(
			card["a" /* default */],
			null,
			Object(preact_min["h"])(
				'div',
				{ 'class': live_style_default.a.rain_layout },
				Object(preact_min["h"])(
					'div',
					{ 'class': live_style_default.a.rain_section_left },
					Object(preact_min["h"])(
						'div',
						{ 'class': live_style_default.a.rain_rate },
						Object(preact_min["h"])(rain_rate_status, { rainRate: data.currentRainRate, description: data.currentConditions, rainUnit: rainUnit, rainRateFormatter: rainRateFormatter })
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': live_style_default.a.rain_hourly_daily },
						Object(preact_min["h"])(data_line, { label: 'Rain last hour', value: rainFormatter(data.currentHourlyRain), unit: ' ' + rainUnit }),
						Object(preact_min["h"])(data_line, { label: 'Rain today', value: rainFormatter(data.rainToday), unit: ' ' + rainUnit })
					)
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': live_style_default.a.rain_section_right },
					Object(preact_min["h"])(
						'div',
						{ 'class': live_style_default.a.rain_month_year },
						Object(preact_min["h"])(data_line, { label: 'Rain this month', value: rainFormatter(data.rainThisMonth), unit: ' ' + rainUnit }),
						Object(preact_min["h"])(data_line, { label: 'Rain this year', value: rainFormatter(data.rainThisYear), unit: ' ' + rainUnit })
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': live_style_default.a.pressure },
						Object(preact_min["h"])(data_line, { label: 'Pressure', value: pressureFormatter(data.currentPressure), unit: ' ' + pressureUnit }),
						Object(preact_min["h"])(data_line, { label: 'Trend', value: pressureTrendPrefix + pressureFormatter(data.pressureTrend), unit: ' ' + pressureUnit + '/hr' })
					)
				)
			)
		);
	};

	return RainSummary;
}(preact_min["Component"]);

/* harmony default export */ var rain_summary = (rain_summary_RainSummary);
// EXTERNAL MODULE: ./components/live-panel/style.scss
var live_panel_style = __webpack_require__("SAA0");
var live_panel_style_default = /*#__PURE__*/__webpack_require__.n(live_panel_style);

// EXTERNAL MODULE: ./components/handle-loading-and-error/index.js + 1 modules
var handle_loading_and_error = __webpack_require__("/zgt");

// CONCATENATED MODULE: ./components/live-panel/index.js


function live_panel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function live_panel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function live_panel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











/**
 * The LivePanel component is responsible for displaying the main panel on the
 * live page, where all the current live data is shown.
 *
 * props:
 * - data: full live data object from the api
 */

var live_panel_LivePanel = function (_Component) {
	live_panel__inherits(LivePanel, _Component);

	function LivePanel(props, context) {
		live_panel__classCallCheck(this, LivePanel);

		var _this = live_panel__possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.units = context.userSettings.units;

		_this.formatters = {
			time: Object(formatters["j" /* getDateTimeFormatConverter */])('%H:%M', '%X'),
			temperature: function temperature(t) {
				return Object(formatters["f" /* formatTemperature */])(t, _this.units.temperature);
			},
			temperatureTrend: function temperatureTrend(t) {
				return Object(formatters["g" /* formatTemperatureInterval */])(t, _this.units.temperature);
			},
			rainfall: function rainfall(t) {
				return Object(formatters["e" /* formatRainfall */])(t, _this.units.rain);
			},
			rainRate: function rainRate(t) {
				return Object(formatters["d" /* formatRainRate */])(t, _this.units.rain);
			},
			pressure: function pressure(t) {
				return Object(formatters["c" /* formatPressure */])(t, _this.units.pressure);
			},
			windSpeed: function windSpeed(t) {
				return Object(formatters["i" /* formatWindSpeed */])(t, _this.units.speed);
			},
			windGust: function windGust(t) {
				return Object(formatters["h" /* formatWindGust */])(t, _this.units.speed);
			}
		};
		return _this;
	}

	LivePanel.prototype.render = function render(props) {

		var temperatureData = extractTemperatureSummaryData(props.data);
		var windData = extractWindSummaryData(props.data);
		var rainData = extractRainSummaryData(props.data);

		return Object(preact_min["h"])(
			'div',
			{ 'class': live_panel_style_default.a.primary_layout },
			Object(preact_min["h"])(
				'div',
				{ 'class': live_panel_style_default.a.primary_box },
				Object(preact_min["h"])(temperature_summary, { data: temperatureData,
					temperatureFormatter: this.formatters.temperature,
					temperatureTrendFormatter: this.formatters.temperatureTrend,
					timeFormatter: this.formatters.time,
					temperatureUnit: this.units.temperature })
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': live_panel_style_default.a.primary_box },
				Object(preact_min["h"])(wind_summary, { data: windData,
					windSpeedFormatter: this.formatters.windSpeed,
					windGustFormatter: this.formatters.windGust,
					timeFormatter: this.formatters.time,
					speedUnit: this.units.speed })
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': live_panel_style_default.a.primary_box },
				Object(preact_min["h"])(rain_summary, { data: rainData,
					rainFormatter: this.formatters.rainfall,
					rainRateFormatter: this.formatters.rainRate,
					pressureFormatter: this.formatters.pressure,
					rainUnit: this.units.rain,
					pressureUnit: this.units.pressure })
			)
		);
	};

	return LivePanel;
}(preact_min["Component"]);

;

/* harmony default export */ var live_panel = (Object(handle_loading_and_error["a" /* default */])(live_panel_LivePanel));
// EXTERNAL MODULE: ./routes/live/style.scss
var routes_live_style = __webpack_require__("9ui9");
var routes_live_style_default = /*#__PURE__*/__webpack_require__.n(routes_live_style);

// EXTERNAL MODULE: ./components/no-data/index.js
var no_data = __webpack_require__("FE+1");

// EXTERNAL MODULE: ./components/button-group/index.js
var button_group = __webpack_require__("reV9");

// EXTERNAL MODULE: ./components/hourly-observations/index.js + 3 modules
var hourly_observations = __webpack_require__("tEJ4");

// EXTERNAL MODULE: ./components/daily-observations/index.js + 3 modules
var daily_observations = __webpack_require__("yCrg");

// EXTERNAL MODULE: ./components/stale-data-message/index.js
var stale_data_message = __webpack_require__("esRP");

// EXTERNAL MODULE: ./utils/tracking.js
var tracking = __webpack_require__("x4D6");

// EXTERNAL MODULE: ./components/page-title/index.js
var page_title = __webpack_require__("O7V0");

// EXTERNAL MODULE: ./components/table/index.js
var table = __webpack_require__("5Xep");

// EXTERNAL MODULE: ./components/sun-moon-info/style.scss
var sun_moon_info_style = __webpack_require__("NDTo");
var sun_moon_info_style_default = /*#__PURE__*/__webpack_require__.n(sun_moon_info_style);

// EXTERNAL MODULE: ./components/card-date-label/index.js
var card_date_label = __webpack_require__("iZj6");

// CONCATENATED MODULE: ./components/sun-moon-info/index.js


function sun_moon_info__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function sun_moon_info__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function sun_moon_info__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The SunMoonInfo component displays basic sun and moon information -
 * sunrise and set, moonrise and set, moon phase.
 *
 * props:
 * - data: `sunMoon` sub-object from the full live data api response.
 */

var sun_moon_info__ref = Object(preact_min["h"])(
	'td',
	null,
	'Sunrise'
);

var sun_moon_info__ref2 = Object(preact_min["h"])(
	'td',
	null,
	'Sunset'
);

var sun_moon_info__ref3 = Object(preact_min["h"])(
	'td',
	null,
	'Moonrise'
);

var _ref4 = Object(preact_min["h"])(
	'td',
	null,
	'Moonset'
);

var _ref5 = Object(preact_min["h"])(
	'td',
	null,
	'Moon Phase'
);

var sun_moon_info_SunMoonInfo = function (_Component) {
	sun_moon_info__inherits(SunMoonInfo, _Component);

	function SunMoonInfo(props) {
		sun_moon_info__classCallCheck(this, SunMoonInfo);

		var _this = sun_moon_info__possibleConstructorReturn(this, _Component.call(this, props));

		_this.timeFormatter = Object(formatters["j" /* getDateTimeFormatConverter */])('%H:%M', '%-I:%M %p');
		_this.dateFormatter = Object(formatters["j" /* getDateTimeFormatConverter */])('%Y-%m-%d', '%-d %B');
		return _this;
	}

	SunMoonInfo.prototype.render = function render(props) {
		var date = this.dateFormatter(props.data.date);

		var validRegex = /^[0-9]{2}:[0-9]{2}$/;

		var moonrise = validRegex.test(props.data.moonrise) ? this.timeFormatter(props.data.moonrise) : '---';

		var moonset = validRegex.test(props.data.moonset) ? this.timeFormatter(props.data.moonset) : '---';

		return Object(preact_min["h"])(
			'div',
			{ 'class': sun_moon_info_style_default.a.sun_moon },
			Object(preact_min["h"])(card_date_label["a" /* default */], { date: date }),
			Object(preact_min["h"])(
				table["a" /* default */],
				null,
				Object(preact_min["h"])(
					'tbody',
					null,
					Object(preact_min["h"])(
						'tr',
						null,
						sun_moon_info__ref,
						Object(preact_min["h"])(
							'td',
							null,
							this.timeFormatter(props.data.sunrise)
						)
					),
					Object(preact_min["h"])(
						'tr',
						null,
						sun_moon_info__ref2,
						Object(preact_min["h"])(
							'td',
							null,
							this.timeFormatter(props.data.sunset)
						)
					),
					Object(preact_min["h"])(
						'tr',
						null,
						sun_moon_info__ref3,
						Object(preact_min["h"])(
							'td',
							null,
							moonrise
						)
					),
					Object(preact_min["h"])(
						'tr',
						null,
						_ref4,
						Object(preact_min["h"])(
							'td',
							null,
							moonset
						)
					),
					Object(preact_min["h"])(
						'tr',
						null,
						_ref5,
						Object(preact_min["h"])(
							'td',
							null,
							props.data.moonPhase
						)
					)
				)
			)
		);
	};

	return SunMoonInfo;
}(preact_min["Component"]);

/* harmony default export */ var sun_moon_info = (Object(handle_loading_and_error["a" /* default */])(sun_moon_info_SunMoonInfo));
// EXTERNAL MODULE: ./components/today-in-previous-years/style.scss
var today_in_previous_years_style = __webpack_require__("MBDq");
var today_in_previous_years_style_default = /*#__PURE__*/__webpack_require__.n(today_in_previous_years_style);

// EXTERNAL MODULE: ./components/highlight-values/index.js
var highlight_values = __webpack_require__("C3gn");

// CONCATENATED MODULE: ./components/today-in-previous-years/index.js


function today_in_previous_years__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function today_in_previous_years__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function today_in_previous_years__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/**
 * The TodayInPreviousYears component displays some extremes data
 * from previous years
 */

var today_in_previous_years__ref = Object(preact_min["h"])(
	'td',
	null,
	'Highest temperature'
);

var today_in_previous_years__ref2 = Object(preact_min["h"])(
	'td',
	null,
	'Lowest temperature'
);

var today_in_previous_years__ref3 = Object(preact_min["h"])(
	'td',
	null,
	'Mean temperature'
);

var today_in_previous_years__ref4 = Object(preact_min["h"])('td', null);

var today_in_previous_years__ref5 = Object(preact_min["h"])(
	'td',
	null,
	'Highest wind gust'
);

var _ref6 = Object(preact_min["h"])(
	'td',
	null,
	'Highest rainfall'
);

var today_in_previous_years_TodayInPreviousYears = function (_Component) {
	today_in_previous_years__inherits(TodayInPreviousYears, _Component);

	function TodayInPreviousYears(props, context) {
		today_in_previous_years__classCallCheck(this, TodayInPreviousYears);

		var _this = today_in_previous_years__possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.units = context.userSettings.units;

		_this.formatters = {
			date: Object(formatters["j" /* getDateTimeFormatConverter */])('%Y-%m-%d', '%-d %B'),
			temperature: function temperature(t) {
				return Object(formatters["f" /* formatTemperature */])(t, _this.units.temperature);
			},
			windGust: function windGust(g) {
				return Object(formatters["h" /* formatWindGust */])(g, _this.units.speed);
			},
			rainfall: function rainfall(r) {
				return Object(formatters["e" /* formatRainfall */])(r, _this.units.rain);
			}
		};
		return _this;
	}

	TodayInPreviousYears.prototype.render = function render(props) {
		var date = this.formatters.date(props.data.date);

		return Object(preact_min["h"])(
			'div',
			{ 'class': today_in_previous_years_style_default.a.today_in_previous_years },
			Object(preact_min["h"])(card_date_label["a" /* default */], { date: date }),
			Object(preact_min["h"])(
				table["a" /* default */],
				null,
				Object(preact_min["h"])(
					'tbody',
					null,
					Object(preact_min["h"])(
						'tr',
						null,
						today_in_previous_years__ref,
						Object(preact_min["h"])(
							'td',
							null,
							Object(preact_min["h"])(
								highlight_values["a" /* HighlightHighTemperature */],
								null,
								this.formatters.temperature(props.data.highestTemperature.value) + '°' + this.units.temperature
							)
						),
						Object(preact_min["h"])(
							'td',
							null,
							props.data.highestTemperature.year
						)
					),
					Object(preact_min["h"])(
						'tr',
						null,
						today_in_previous_years__ref2,
						Object(preact_min["h"])(
							'td',
							null,
							Object(preact_min["h"])(
								highlight_values["b" /* HighlightLowTemperature */],
								null,
								this.formatters.temperature(props.data.lowestTemperature.value) + '°' + this.units.temperature
							)
						),
						Object(preact_min["h"])(
							'td',
							null,
							props.data.lowestTemperature.year
						)
					),
					Object(preact_min["h"])(
						'tr',
						null,
						today_in_previous_years__ref3,
						Object(preact_min["h"])(
							'td',
							null,
							Object(preact_min["h"])(
								highlight_values["c" /* HighlightMeanTemperature */],
								null,
								this.formatters.temperature(props.data.meanTemperature.value) + '°' + this.units.temperature
							)
						),
						today_in_previous_years__ref4
					),
					Object(preact_min["h"])(
						'tr',
						null,
						today_in_previous_years__ref5,
						Object(preact_min["h"])(
							'td',
							null,
							Object(preact_min["h"])(
								highlight_values["e" /* HighlightWindGust */],
								null,
								Object(convert_wind_bearing["b" /* convertWindBearing8 */])(props.data.highestWindGust.bearing) + ' ' + this.formatters.windGust(props.data.highestWindGust.value) + ' ' + this.units.speed
							)
						),
						Object(preact_min["h"])(
							'td',
							null,
							props.data.highestWindGust.year
						)
					),
					Object(preact_min["h"])(
						'tr',
						null,
						_ref6,
						Object(preact_min["h"])(
							'td',
							null,
							Object(preact_min["h"])(
								highlight_values["d" /* HighlightRainfall */],
								null,
								this.formatters.rainfall(props.data.highestRainfall.value) + ' ' + this.units.rain
							)
						),
						Object(preact_min["h"])(
							'td',
							null,
							props.data.highestRainfall.year
						)
					)
				)
			)
		);
	};

	return TodayInPreviousYears;
}(preact_min["Component"]);

/* harmony default export */ var today_in_previous_years = (Object(handle_loading_and_error["a" /* default */])(today_in_previous_years_TodayInPreviousYears));
// CONCATENATED MODULE: ../node_modules/babel-loader/lib??ref--0!./routes/live/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function live__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function live__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function live__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var live__ref = Object(preact_min["h"])(
	page_title["a" /* default */],
	null,
	'Live Weather Conditions'
);

var live__ref2 = Object(preact_min["h"])(no_data["a" /* NoData */], null);

var live_LivePage = function (_Component) {
	live__inherits(LivePage, _Component);

	function LivePage(props, context) {
		live__classCallCheck(this, LivePage);

		var _this = live__possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.observationsOptions = [{ value: OBSERVATIONS_VIEW.HOURLY, label: '24 hrs' }, { value: OBSERVATIONS_VIEW.DAILY, label: '30 days' }];

		_this.state = initialState();

		_this.liveUpdateFrequency = 5000;
		_this.liveUpdatePeriod = 600000;
		_this.liveChartPeriod = 240000; // ms

		_this.hourlyObservationsOutdated = false;
		_this.dailyObservationsOutdated = false;

		_this.lastUpdateTimestamp = null;
		_this.units = context.userSettings.units;

		// store references to timers scheduling tasks in the future, so we can clear
		// and pending tasks when the component is unmounted.
		_this.liveDataTimer = null;
		_this.liveDataId = null;
		_this.hourlyObservationsTimer = null;
		_this.dailyObservationsTimer = null;
		_this.yesterdayExtremesTimer = null;

		_this.startLiveUpdateTimer = _this.startLiveUpdateTimer.bind(_this);
		_this.fetchLiveData = _this.fetchLiveData.bind(_this);
		_this.fetchTodayHistoryData = _this.fetchTodayHistoryData.bind(_this);
		_this.fetchYesterdayExtremes = _this.fetchYesterdayExtremes.bind(_this);
		_this.fetchHourlyObservations = _this.fetchHourlyObservations.bind(_this);
		_this.fetchDailyObservations = _this.fetchDailyObservations.bind(_this);
		_this.switchObservationsView = _this.switchObservationsView.bind(_this);

		_this.requestAbort = {
			live: null,
			hourlyObs: null,
			dailyObs: null,
			yesterday: null,
			todayHistory: null
		};
		return _this;
	}

	LivePage.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		this.startLiveUpdateTimer(false);
		this.fetchYesterdayExtremes();
		this.fetchTodayHistoryData();

		if (this.state.activeObservationsView === OBSERVATIONS_VIEW.HOURLY) {
			this.fetchHourlyObservations();
		} else if (this.state.activeObservationsView === OBSERVATIONS_VIEW.DAILY) {
			this.fetchDailyObservations();
		}

		this.context.titleService.update('Live');
		this.context.tracking.recordPageView();

		var hidden = void 0,
		    visibilityChange = void 0;
		if (typeof document.hidden !== 'undefined') {
			hidden = 'hidden';
			visibilityChange = 'visibilitychange';
		} else if (typeof document.msHidden !== 'undefined') {
			hidden = 'msHidden';
			visibilityChange = 'msvisibilitychange';
		} else if (typeof document.webkitHidden !== 'undefined') {
			hidden = 'webkitHidden';
			visibilityChange = 'webkitvisibilitychange';
		}

		this.visibilityChangeHandler = function () {
			if (document[hidden]) {
				_this2.stopLiveUpdateTimer();
			} else {
				_this2.startLiveUpdateTimer(false);
			}
		};

		document.addEventListener(visibilityChange, this.visibilityChangeHandler);
	};

	LivePage.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		// If the user goes offline, stop live updates polling.
		// If the user comes online again, restart the live updates polling.
		if (nextProps.isOnline !== this.props.isOnline) {
			if (nextProps.isOnline) {
				this.startLiveUpdateTimer(false);
			} else {
				this.stopLiveUpdateTimer();
			}
		}
	};

	LivePage.prototype.componentWillUnmount = function componentWillUnmount() {
		this.stopLiveUpdateTimer();

		if (this.hourlyObservationsTimer !== null) {
			clearTimeout(this.hourlyObservationsTimer);
		}

		if (this.dailyObservationsTimer !== null) {
			clearTimeout(this.dailyObservationsTimer);
		}

		if (this.yesterdayExtremesTimer !== null) {
			clearTimeout(this.yesterdayExtremesTimer);
		}

		// Abort any pending requests
		Object(api["b" /* abortRequests */])(this.requestAbort);

		document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
	};

	LivePage.prototype.startLiveUpdateTimer = function startLiveUpdateTimer() {
		var _this3 = this;

		var recordEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;


		if (recordEvent) {
			// User has restarted updates
			this.context.tracking.recordEvent(tracking["a" /* EVENT_ACTION */].LIVE_RESTART_UPDATES, tracking["b" /* EVENT_CATEGORY */].LIVE);
		}

		// In case this somehow gets double-triggered, clear the existing timeout
		this.stopLiveUpdateTimer();

		this.setState(resumeLiveUpdates());

		this.liveDataStartTime = new Date().getTime();

		if (this.context.userSettings.ui.liveUpdatesEnabled) {
			this.liveDataTimer = setInterval(function () {

				_this3.fetchLiveData().then(function () {
					// If the next update would go beyond the live data period, pause the updates
					if (new Date().getTime() + _this3.liveUpdateFrequency - _this3.liveDataStartTime > _this3.liveUpdatePeriod) {

						_this3.setState(pauseLiveUpdates());
						_this3.stopLiveUpdateTimer();
					}
				});
			}, this.liveUpdateFrequency);
		}

		// Fire off the first update immediately
		this.fetchLiveData();
	};

	LivePage.prototype.stopLiveUpdateTimer = function stopLiveUpdateTimer() {
		if (this.liveDataTimer !== null) {
			clearInterval(this.liveDataTimer);
			this.liveDataTimer = null;
		}
	};

	LivePage.prototype.switchObservationsView = function switchObservationsView(view) {
		this.setState(reducers_switchObservationsView(view));

		this.context.tracking.recordEvent(tracking["a" /* EVENT_ACTION */].LIVE_TOGGLE_OBS_VIEW.replace('%1', view), tracking["b" /* EVENT_CATEGORY */].LIVE);

		if (view === OBSERVATIONS_VIEW.HOURLY) {

			// Do a fetch if the obs are marked as outdated explicity, or if the data is not currently present
			// and is not in the process of loading.
			var doFetch = this.hourlyObservationsOutdated || !this.state.hourlyObservations && !this.state.hourlyObservationsLoading;

			if (doFetch) {
				this.fetchHourlyObservations();
			}
		} else if (view === OBSERVATIONS_VIEW.DAILY) {

			// Do a fetch if the obs are marked as outdated explicity, or if the data is not currently present
			// and is not in the process of loading.
			var _doFetch = this.dailyObservationsOutdated || !this.state.dailyObservations && !this.state.dailyObservationsLoading;

			if (_doFetch) {
				this.fetchDailyObservations();
			}
		}
	};

	LivePage.prototype.fetchLiveData = function fetchLiveData() {
		var _this4 = this;

		this.setState(liveDataLoading());

		var params = {};

		if (this.liveDataId !== null) {
			params.since = this.liveDataId;
		}

		var request = Object(api["i" /* fetchLiveData */])(params);
		this.requestAbort.live = request.abort;

		return request.promise.then(function (res) {
			if (res.data.unchanged === true) {
				// Data has not changed since the previous update
				_this4.setState(liveDataLoadSuccess(null));
			} else {
				_this4.liveDataSuccess(res.data);
			}
		}).catch(function (err) {
			// ignore abort error
			if (err.name !== api["a" /* ABORT_ERROR_NAME */]) {
				_this4.setState(function (state) {
					return liveDataLoadFailure(state);
				});
				_this4.context.tracking.recordException('Error loading live data', err);
			}
		});
	};

	LivePage.prototype.liveDataSuccess = function liveDataSuccess(data) {
		var _this5 = this;

		var timestamp = data.data.date + ' ' + data.data.time;

		this.liveDataId = data.id;
		this.setState(liveDataLoadSuccess(data));

		if (this.lastUpdateTimestamp !== null) {

			var dateConverter = Object(formatters["j" /* getDateTimeFormatConverter */])('%Y-%m-%d %H:%M:%S', '%Q');

			var d1 = new Date(Number(dateConverter(this.lastUpdateTimestamp)));
			var d2 = new Date(Number(dateConverter(timestamp)));

			// Check if the time has crossed an hour mark
			if (d1.toDateString() !== d2.toDateString() || d1.getHours() < d2.getHours()) {

				var exactHr = new Date(Number(dateConverter(timestamp)));
				exactHr.setMinutes(0);
				exactHr.setSeconds(0);

				// max timeout of 5 seconds before reloading the hourly obs.
				var diff = d2.getTime() - exactHr.getTime();
				var timeout = Math.max(0, 5000 - diff);

				// Trigger a reload of hourly observations if that is the active observations view,
				// otherwise mark the hourly observations as outdated.
				if (this.state.activeObservationsView === OBSERVATIONS_VIEW.HOURLY) {
					this.hourlyObservationsTimer = setTimeout(function () {
						return _this5.fetchHourlyObservations();
					}, timeout);
				} else {
					this.hourlyObservationsOutdated = true;
				}
			}

			// Check if the time has crossed a midnight mark into a new day
			if (d1.toDateString() !== d2.toDateString()) {

				var exactDay = new Date(Number(dateConverter(timestamp)));
				exactDay.setHours(0);
				exactDay.setMinutes(0);
				exactDay.setSeconds(0);

				// max timeout of 5 seconds before reloading the daily obs / yesterday extremes.
				var _diff = d2.getTime() - exactDay.getTime();
				var _timeout = Math.max(0, 5000 - _diff);

				// Trigger reload of yesterday's extremes after a short period (allow time for DB to update)
				// And fetch the today history data again.
				this.yesterdayExtremesTimer = setTimeout(function () {
					_this5.fetchYesterdayExtremes();
					_this5.fetchTodayHistoryData();
				}, _timeout);

				// Trigger a reload of daily observations if that is the active observations view,
				// otherwise mark the daily observations as outdated.
				if (this.state.activeObservationsView === OBSERVATIONS_VIEW.DAILY) {
					this.dailyObservationsTimer = setTimeout(function () {
						return _this5.fetchDailyObservations();
					}, _timeout);
				} else {
					this.dailyObservationsOutdated = true;
				}
			}
		}

		this.lastUpdateTimestamp = timestamp;
	};

	LivePage.prototype.fetchTodayHistoryData = function fetchTodayHistoryData() {
		var _this6 = this;

		this.setState(todayHistoryLoading());

		var request = Object(api["o" /* fetchTodayHistory */])();
		this.requestAbort.todayHistory = request.abort;

		request.promise.then(function (res) {
			_this6.setState(todayHistoryLoadSuccess(res.data));
		}).catch(function (err) {
			if (err.name !== api["a" /* ABORT_ERROR_NAME */]) {
				_this6.setState(function (state) {
					return todayHistoryLoadFailure(state);
				});
				_this6.context.tracking.recordException('Error loading today history data', err);
			}
		});
	};

	LivePage.prototype.fetchHourlyObservations = function fetchHourlyObservations() {
		var _this7 = this;

		this.setState(hourlyObservationsLoading());

		var params = {
			range: '24h',
			parameters: ['temperature', 'hourlyRainfall', 'windBearing', 'hourlyHighWindGust'],
			excludeDayEnd: 1
		};

		var request = Object(api["m" /* fetchObservationsHourly */])(params);
		this.requestAbort.hourlyObs = request.abort;

		request.promise.then(function (res) {
			_this7.hourlyObservationsOutdated = false;
			_this7.setState(hourlyObservationsLoadSuccess(res.data.observations));
		}).catch(function (err) {
			if (err.name !== api["a" /* ABORT_ERROR_NAME */]) {
				_this7.setState(function (state) {
					return hourlyObservationsLoadFailure(state);
				});
				_this7.context.tracking.recordException('Error loading recent hourly observations', err);
			}
		});
	};

	LivePage.prototype.fetchDailyObservations = function fetchDailyObservations() {
		var _this8 = this;

		this.setState(dailyObservationsLoading());

		var params = {
			range: '30d',
			parameters: ['highTemperature', 'lowTemperature', 'avgTemperature', 'rainfall', 'highWindGust', 'highWindGustBearing']
		};

		var request = Object(api["g" /* fetchDailyExtremes */])(params);
		this.requestAbort.dailyObs = request.abort;

		request.promise.then(function (res) {
			_this8.dailyObservationsOutdated = false;
			_this8.setState(dailyObservationsLoadSuccess(res.data));
		}).catch(function (err) {
			if (err.name !== api["a" /* ABORT_ERROR_NAME */]) {
				_this8.setState(function (state) {
					return dailyObservationsLoadFailure(state);
				});
				_this8.context.tracking.recordException('Error loading recent daily observations', err);
			}
		});
	};

	LivePage.prototype.fetchYesterdayExtremes = function fetchYesterdayExtremes() {
		var _this9 = this;

		this.setState(yesterdayExtremesLoading());

		var request = Object(api["g" /* fetchDailyExtremes */])({ date: 'latest' });
		this.requestAbort.yesterday = request.abort;

		request.promise.then(function (res) {
			_this9.setState(yesterdayExtremesLoadSuccess(res.data));
		}).catch(function (err) {
			if (err.name !== api["a" /* ABORT_ERROR_NAME */]) {
				_this9.setState(function (state) {
					return yesterdayExtremesLoadFailure(state);
				});
				_this9.context.tracking.recordException('Error loading yesterday extremes', err);
			}
		});
	};

	LivePage.prototype.renderHourlyObservations = function renderHourlyObservations() {
		var isListAlwaysExpanded = this.context.userSettings.ui.alwaysExpandRecentObsList;

		return Object(preact_min["h"])(hourly_observations["a" /* default */], { data: this.state.hourlyObservations,
			listDescending: true,
			listAlwaysExpanded: isListAlwaysExpanded,
			isLoading: this.state.hourlyObservationsLoading,
			retryCount: this.state.hourlyObservationsRetryCount,
			retryHandler: this.fetchHourlyObservations,
			errorMessage: 'Unable to load hourly observations' });
	};

	LivePage.prototype.renderDailyObservations = function renderDailyObservations() {
		var isListAlwaysExpanded = this.context.userSettings.ui.alwaysExpandRecentObsList;

		return Object(preact_min["h"])(daily_observations["a" /* default */], { data: this.state.dailyObservations,
			listDescending: true,
			listAlwaysExpanded: isListAlwaysExpanded,
			isLoading: this.state.dailyObservationsLoading,
			retryCount: this.state.dailyObservationsRetryCount,
			retryHandler: this.fetchDailyObservations,
			errorMessage: 'Unable to load daily observations' });
	};

	LivePage.prototype.renderStaleDataMessage = function renderStaleDataMessage() {
		if (this.state.liveData && this.state.freshness > 3600) {
			var timestamp = this.state.liveData.date + ' ' + this.state.liveData.time;
			return Object(preact_min["h"])(stale_data_message["a" /* default */], { freshness: this.state.freshness, timestamp: timestamp });
		}

		return null;
	};

	LivePage.prototype.renderLivePanel = function renderLivePanel() {
		return Object(preact_min["h"])(live_panel, { data: this.state.liveData,
			isLoading: this.state.liveDataLoading,
			retryCount: this.state.liveDataRetryCount,
			retryHandler: this.fetchLiveData,
			errorMessage: 'Unable to load live data',
			wrapLoadingErrorInCard: true });
	};

	LivePage.prototype.render = function render(props) {
		var data = this.state.liveData;

		var todaysExtremes = data ? extractDailyExtremes(data) : data;

		var isNoYesterdayExtremesData = this.state.yesterdayExtremes && this.state.yesterdayExtremes.length === 0;

		var yesterdayExtremes = this.state.yesterdayExtremes ? this.state.yesterdayExtremes[0] : this.state.yesterdayExtremes;

		var sunMoonInfo = data ? _extends({}, data.sunMoon, { date: data.date }) : data;

		return Object(preact_min["h"])(
			'div',
			null,
			live__ref,
			Object(preact_min["h"])(live_updated_time, { date: data ? data.date : null,
				time: data ? data.time : null,
				isPaused: this.state.liveUpdatesPaused,
				resume: this.startLiveUpdateTimer,
				lastUpdateStatus: this.state.lastUpdateStatus,
				liveDataLoadTime: this.state.liveDataLoadTime }),
			Object(preact_min["h"])(
				'div',
				{ 'class': routes_live_style_default.a.conditions_status },
				'Conditions: ',
				data ? data.conditions : '---'
			),
			this.renderStaleDataMessage(),
			this.renderLivePanel(),
			Object(preact_min["h"])(
				card["a" /* default */],
				{ cardTitle: 'Recent Observations' },
				Object(preact_min["h"])(
					'div',
					{ 'class': routes_live_style_default.a.recent_obs },
					Object(preact_min["h"])(
						'div',
						{ 'class': routes_live_style_default.a.recent_obs_btns },
						Object(preact_min["h"])(button_group["a" /* default */], { options: this.observationsOptions,
							activeOption: this.state.activeObservationsView,
							onBtnClick: this.switchObservationsView })
					),
					this.state.activeObservationsView === OBSERVATIONS_VIEW.HOURLY ? this.renderHourlyObservations() : this.renderDailyObservations()
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': routes_live_style_default.a.secondary_layout },
				Object(preact_min["h"])(
					'div',
					{ 'class': routes_live_style_default.a.secondary_box },
					Object(preact_min["h"])(
						card["a" /* default */],
						{ cardTitle: 'Today\'s Extremes' },
						Object(preact_min["h"])(daily_summary["a" /* default */], { data: todaysExtremes,
							isLoading: this.state.liveDataLoading,
							errorMessage: 'Unable to load today\'s extremes data',
							retryHandler: this.fetchLiveData,
							retryCount: this.state.liveDataRetryCount })
					)
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': routes_live_style_default.a.secondary_box },
					Object(preact_min["h"])(
						card["a" /* default */],
						{ cardTitle: 'Yesterday\'s Extremes' },
						isNoYesterdayExtremesData ? live__ref2 : Object(preact_min["h"])(daily_summary["a" /* default */], { data: yesterdayExtremes,
							isLoading: this.state.yesterdayExtremesLoading,
							errorMessage: 'Unable to load yesterday\'s extremes data',
							retryHandler: this.fetchYesterdayExtremes,
							retryCount: this.state.yesterdayExtremesRetryCount })
					)
				)
			),
			Object(preact_min["h"])(
				'div',
				{ 'class': [routes_live_style_default.a.secondary_layout, routes_live_style_default.a.final_layout].join(' ') },
				Object(preact_min["h"])(
					'div',
					{ 'class': routes_live_style_default.a.secondary_box },
					Object(preact_min["h"])(
						card["a" /* default */],
						{ cardTitle: 'Today in Previous Years' },
						Object(preact_min["h"])(today_in_previous_years, { data: this.state.todayHistory,
							isLoading: this.state.todayHistoryLoading,
							retryCount: this.state.todayHistoryRetryCount,
							retryHandler: this.fetchTodayHistoryData,
							errorMessage: 'Unable to load today history data' })
					)
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': routes_live_style_default.a.secondary_box },
					Object(preact_min["h"])(
						card["a" /* default */],
						{ cardTitle: 'Sun and Moon' },
						Object(preact_min["h"])(sun_moon_info, { data: sunMoonInfo,
							isLoading: this.state.liveDataLoading,
							retryCount: this.state.liveDataRetryCount,
							retryHandler: this.fetchLiveData,
							errorMessage: 'Unable to load sun/moon info' })
					)
				)
			)
		);
	};

	return LivePage;
}(preact_min["Component"]);

/* harmony default export */ var live = __webpack_exports__["default"] = (live_LivePage);

/***/ }),

/***/ "iZj6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__("N6T2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);



/**
 * Displays a small date label in the top right portion of a card.
 * NOTE: needs to be inside a container with relative positioning.
 *
 * props:
 * - date: formatted date string to be displayed
 */
var CardDateLabel = function CardDateLabel(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'span',
    { 'class': __WEBPACK_IMPORTED_MODULE_1__style_scss___default.a.date_label },
    props.date
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CardDateLabel);

/***/ }),

/***/ "jb/y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"rain_icon_light":"rain_icon_light__1l6Rw","rain_icon_moderate":"rain_icon_moderate__1eGrJ","rain_icon_heavy":"rain_icon_heavy__1dch6","rain_icon_very_heavy":"rain_icon_very_heavy__2quJZ","rain_rate_box":"rain_rate_box__3tN4M","rain_rate_descriptor":"rain_rate_descriptor__3XPW4","rain_rate_value":"rain_rate_value__BzfCE","rain_rate_dry":"rain_rate_dry__3o1Hz","rain_rate_data":"rain_rate_data__3ad9w","rain_rate_unit":"rain_rate_unit__1nkGh"};

/***/ }),

/***/ "tEJ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/d3-array/src/index.js + 31 modules
var src = __webpack_require__("K0bd");

// EXTERNAL MODULE: ./utils/convert-wind-bearing.js
var convert_wind_bearing = __webpack_require__("Dqzv");

// EXTERNAL MODULE: ./utils/interpolators.js
var interpolators = __webpack_require__("VqWv");

// EXTERNAL MODULE: ./components/rain-drop/index.js
var rain_drop = __webpack_require__("6hGj");

// EXTERNAL MODULE: ./components/button/index.js
var components_button = __webpack_require__("rAoZ");

// EXTERNAL MODULE: ./utils/formatters.js
var formatters = __webpack_require__("gNwm");

// EXTERNAL MODULE: ./components/hourly-list/style.scss
var style = __webpack_require__("HgUS");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./utils/unit-converters.js
var unit_converters = __webpack_require__("rbCG");

// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// CONCATENATED MODULE: ./components/hourly-list/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













/**
 * The HourlyList component displays a list of hourly observations, in a vertical arrangement.
 * It is used instead of the HourlyChartWrapper component on smaller screens where there is
 * insufficient width to draw a chart.
 *
 * NOTE: data passed down is already converted into the units set by the user.
 *
 * props:
 * - data: An array of objects, each containing hourly observation data
 * - descending: optional - set to true to sort in descending order
 */

var hourly_list_HourlyList = function (_Component) {
	_inherits(HourlyList, _Component);

	function HourlyList(props, context) {
		_classCallCheck(this, HourlyList);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.units = context.userSettings.units;
		_this.isExpandedByDefault = context.userSettings.ui.hourlyListExpanded;

		_this.state = {
			isExpanded: _this.isExpandedByDefault
		};

		// Get a light-colour temperature interpolator
		_this.getTemperatureColour = Object(interpolators["b" /* getTemperatureColourInterpolator */])(true, _this.units.temperature);

		var windColour = Object(interpolators["c" /* getWindColourInterpolator */])(_this.units.speed);
		var rainColour = Object(interpolators["a" /* getRainColourInterpolator */])(Object(unit_converters["b" /* convertRainfall */])(15, _this.units.rain));

		_this.getWindColour = function (w) {
			return windColour(w, _this.units.speed);
		};
		_this.getRainColour = function (r) {
			return rainColour(r, _this.units.rain);
		};

		var standardTimeFormatter = Object(formatters["j" /* getDateTimeFormatConverter */])('%Y-%m-%d %H:%M:%S', '%-I %p');

		var timeFormatter = function timeFormatter(t) {
			return t.split(' ')[1] === '23:59:59' ? '12 am' : standardTimeFormatter(t);
		};

		_this.formatters = {
			time: timeFormatter,
			rainfall: function rainfall(r) {
				return Object(formatters["e" /* formatRainfall */])(r, _this.units.rain, true);
			}
		};

		_this.toggleNumItems = _this.toggleNumItems.bind(_this);
		return _this;
	}

	HourlyList.prototype.isExpanded = function isExpanded() {
		return this.props.alwaysExpanded || this.state.isExpanded;
	};

	HourlyList.prototype.getRainTotal = function getRainTotal() {
		var validRainfalls = this.props.data.map(function (ob) {
			return ob.hourlyRainfall;
		}).filter(function (r) {
			return r !== null;
		});

		if (validRainfalls.length === 0) {
			return 'n/a';
		}

		var total = Object(src["sum"])(validRainfalls);

		return this.formatters.rainfall(total) + ' ' + this.units.rain;
	};

	HourlyList.prototype.render = function render(props) {
		var _this2 = this;

		if (!Array.isArray(props.data)) {
			return null;
		}

		var formattedData = this.formatData(props.data);

		if (props.descending) {
			formattedData.reverse(); // display most recent at the top
		}

		return Object(preact_min["h"])(
			'div',
			null,
			props.descending ? Object(preact_min["h"])(
				'p',
				{ 'class': style_default.a.hourly_list_note },
				'Descending order (most recent at the top)'
			) : null,
			Object(preact_min["h"])(
				'ul',
				{ 'class': style_default.a.hourly_list },
				Object(preact_min["h"])(
					'li',
					{ 'class': style_default.a.hourly_list_head },
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.hourly_list_time_column },
						'Time'
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.hourly_list_temp_column },
						'Temp (\xB0',
						this.units.temperature,
						')'
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.hourly_list_rain_column },
						'Rain (',
						this.units.rain,
						')'
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.hourly_list_wind_column },
						'Wind'
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.hourly_list_gust_column },
						'Gust (',
						this.units.speed,
						')'
					)
				),
				formattedData.slice(0, this.isExpanded() ? formattedData.length : 12).map(function (ob) {
					return Object(preact_min["h"])(
						'li',
						{ 'class': style_default.a.hourly_list_row, key: ob.key },
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.hourly_list_time_column },
							_this2.formatters.time(ob.timestamp)
						),
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.hourly_list_temp_column },
							Object(preact_min["h"])(
								'span',
								{ 'class': style_default.a.hourly_list_temperature_cell,
									style: { backgroundColor: _this2.getTemperatureColour(ob.temperature) } },
								ob.temperature
							)
						),
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.hourly_list_rain_column },
							Object(preact_min["h"])(
								'span',
								{ 'class': style_default.a.hourly_list_rain_cell },
								ob.hourlyRainfall === null ? 'n/a' : ob.hourlyRainfall > 0 ? _this2.formatters.rainfall(ob.hourlyRainfall) : '-',
								Object(preact_min["h"])(
									'span',
									{ 'class': style_default.a.hourly_list_raindrop },
									ob.hourlyRainfall > 0 ? Object(preact_min["h"])(rain_drop["a" /* default */], { fill: _this2.getRainColour(ob.hourlyRainfall), size: _this2.getRainDropSize(ob.hourlyRainfall) }) : null
								)
							)
						),
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.hourly_list_wind_column },
							ob.windDirection
						),
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.hourly_list_gust_column },
							Object(preact_min["h"])(
								'span',
								{ 'class': style_default.a.hourly_list_wind_cell,
									style: { backgroundColor: _this2.getWindColour(ob.hourlyHighWindGust) } },
								Object(formatters["h" /* formatWindGust */])(ob.hourlyHighWindGust, _this2.units.speed, true, true)
							)
						)
					);
				})
			),
			this.isExpanded() ? Object(preact_min["h"])(
				'p',
				{ 'class': style_default.a.hourly_list_note },
				'Rain Total = ',
				this.getRainTotal()
			) : null,
			this.renderToggleButton()
		);
	};

	HourlyList.prototype.renderToggleButton = function renderToggleButton() {
		if (this.props.alwaysExpanded) {
			return null;
		}

		return Object(preact_min["h"])(
			components_button["a" /* default */],
			{ wide: true, clickHandler: this.toggleNumItems },
			this.isExpanded() ? 'Show less' : 'Show more'
		);
	};

	HourlyList.prototype.toggleNumItems = function toggleNumItems() {
		this.setState(function (state) {
			return { isExpanded: !state.isExpanded };
		});
	};

	HourlyList.prototype.getRainDropSize = function getRainDropSize(rain) {
		var rainMm = this.units.rain === constants["f" /* RAIN_UNIT */].IN ? rain * 25.4 : rain;
		return Math.min(32, 10 + rainMm);
	};

	HourlyList.prototype.formatData = function formatData(data) {
		return data.map(function (ob, index) {
			var windDirection = ob.hourlyHighWindGust > 0 ? Object(convert_wind_bearing["b" /* convertWindBearing8 */])(ob.windBearing) : '-';

			return _extends({}, ob, {
				windDirection: windDirection,
				key: index
			});
		});
	};

	return HourlyList;
}(preact_min["Component"]);

/* harmony default export */ var hourly_list = (hourly_list_HourlyList);
// EXTERNAL MODULE: ../node_modules/d3-selection/src/index.js + 50 modules
var d3_selection_src = __webpack_require__("//ys");

// EXTERNAL MODULE: ../node_modules/d3-scale/src/index.js + 38 modules
var d3_scale_src = __webpack_require__("zL2z");

// EXTERNAL MODULE: ../node_modules/d3-axis/src/index.js + 3 modules
var d3_axis_src = __webpack_require__("mp0m");

// EXTERNAL MODULE: ../node_modules/d3-shape/src/index.js + 51 modules
var d3_shape_src = __webpack_require__("9maw");

// EXTERNAL MODULE: ./utils/graph-limits.js
var graph_limits = __webpack_require__("VjiX");

// CONCATENATED MODULE: ./utils/hourly-chart.js
var hourly_chart__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function hourly_chart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }













var hourly_chart_HourlyChart = function () {
	function HourlyChart(weatherData, units) {
		var _this = this;

		hourly_chart__classCallCheck(this, HourlyChart);

		this.naText = 'n/a';
		this.missingValue = null;
		this.units = units;

		this.data = weatherData.map(function (d) {
			return hourly_chart__extends({}, d, {
				key: d.time,
				hour: Number(d.timestamp.split(' ')[1].split(':')[0])
			});
		});

		this.keyFn = function (d) {
			return d.key;
		};
		this.rainFormatter = function (rain) {
			return Object(formatters["e" /* formatRainfall */])(rain, _this.units.rain, true);
		};
	}

	HourlyChart.prototype.render = function render(containerNode) {
		this._init(containerNode);
		this._renderVerticalGridlines();
		this._renderDaySeparator();
		this._renderSectionSeparators();
		this._renderRainfall();
		this._renderTemperature();
		this._renderWind();
		this._renderAxis();
		this._renderLabels();
	};

	HourlyChart.prototype._init = function _init(containerNode) {

		this.container = Object(d3_selection_src["select"])(containerNode);
		var containerDim = this.container.node().getBoundingClientRect();

		this.dim = {
			svgWidth: containerDim.width,
			svgHeight: 420,
			marginTop: 15,
			marginRight: 10,
			marginBottom: 35,
			marginLeft: 10,
			sectionSpacing: 30,
			windSectionHeight: 70
		};

		// If available width is too small, certain things will need adjusting
		this.isSmall = this.dim.svgWidth < 840;

		// Rain section and temperature section height vary depending on how much space if left.
		// The rain section take up 40% of the remaining space, meaning the temperature section takes up 60%.
		var remaining = this.dim.svgHeight - this.dim.marginTop - this.dim.marginBottom - this.dim.windSectionHeight - 2 * this.dim.sectionSpacing;
		this.dim.rainSectionHeight = 0.4 * remaining;
		this.dim.temperatureSectionHeight = 0.6 * remaining;

		// Width of the plot area is the svg width minus the left and right margins.
		this.dim.plotAreaWidth = this.dim.svgWidth - this.dim.marginLeft - this.dim.marginRight;

		// Height of the plot area is the svg height minus the top and bottom margins.
		this.dim.plotAreaHeight = this.dim.svgHeight - this.dim.marginTop - this.dim.marginBottom;

		this.elements = {};

		this.container.html('');

		// Insert the SVG element and apply the margins
		this.elements.svgRoot = this.container.append('svg').attr('width', this.dim.svgWidth).attr('height', this.dim.svgHeight);

		if (this.isSmall) {
			this.elements.svgRoot.attr('class', 'small');
		}

		this._createWindSymbolDefs();

		this.xScale = Object(d3_scale_src["scaleBand"])().domain(this.data.map(function (d) {
			return d.key;
		})).rangeRound([0, this.dim.plotAreaWidth]);

		this.dim.pointWidth = this.xScale.step();

		// Get the SVG context we will be drawing in (simply applies the margins).
		this.elements.plotArea = this.elements.svgRoot.append('g').attr('transform', 'translate(' + this.dim.marginLeft + ',' + this.dim.marginTop + ')');
	};

	HourlyChart.prototype._createWindSymbolDefs = function _createWindSymbolDefs() {

		// Add a shape definition to the SVG. The shape we are defining is an arrow pointing north.
		// This represents a southerly wind direction. Insert this shape into the graphic via <use> elements,
		// and apply a rotate transformation to get the desired wind direction.

		var defs = this.elements.svgRoot.append('defs');

		this.dim.windSymbolSize = 52;

		// Radius of the background circle
		var windSymbolRadius = this.isSmall ? 12 : 14;

		var indicator = defs.append('g').attr('id', 'wind-arrow');

		var y0 = 0.5 * this.dim.windSymbolSize - windSymbolRadius + 3;
		var length = 8;
		var y1 = y0 - length;
		var x0 = 0.5 * (this.dim.windSymbolSize - length * 1.2);
		var x1 = 0.5 * (this.dim.windSymbolSize + length * 1.2);

		indicator.append('path').attr('d', 'M' + x0 + ',' + y1 + ' L' + x1 + ',' + y1 + ' L' + 0.5 * this.dim.windSymbolSize + ',' + y0 + ' L' + x0 + ',' + y1);

		var windSymbol = defs.append('g').attr('id', 'wind-symbol');

		// Use circle shape
		windSymbol.append('circle').attr('cx', 0.5 * this.dim.windSymbolSize).attr('cy', 0.5 * this.dim.windSymbolSize).attr('r', windSymbolRadius);
	};

	HourlyChart.prototype._renderVerticalGridlines = function _renderVerticalGridlines() {
		var _this2 = this;

		var gridlines = this.elements.plotArea.append('g').attr('class', 'background_lines');

		var drawLine = function drawLine(x) {
			gridlines.append('line').attr('class', 'background_line').attr('x1', x).attr('x2', x).attr('y1', _this2.dim.marginTop).attr('y2', _this2.dim.plotAreaHeight);
		};

		this.data.forEach(function (d) {
			if ((d.hour - 1) % 3 === 0) {
				drawLine(_this2.xScale(d.key));
			}
		});

		var lastOb = this.data[this.data.length - 1];

		if (lastOb.hour % 3 === 0) {
			// Add extra background line at the end of the chart
			drawLine(this.xScale(lastOb.key) + this.dim.pointWidth);
		}
	};

	HourlyChart.prototype._renderDaySeparator = function _renderDaySeparator() {

		// Insert day separator(s) between 12am the next time point. To do so, need to get
		// the positions of the two points and average them, then add half the interval width.
		// NOTE: This is not done for the case where 12am is the last x value.

		var n = this.data.length;
		var hours = this.data.map(function (d) {
			return d.hour;
		});

		var indexOfMidnight = hours.indexOf(0);

		while (indexOfMidnight !== -1) {

			if (indexOfMidnight < n - 1) {

				var nextAfterMidnight = this.data[indexOfMidnight + 1].key;
				var midnightLineX = 0.5 * (this.xScale(this.data[indexOfMidnight].key) + this.xScale(nextAfterMidnight)) + 0.5 * this.dim.pointWidth;

				this.elements.plotArea.append('line').attr('transform', 'translate(' + midnightLineX + ',0)').attr('class', 'vertical_separator').attr('x1', 0).attr('x2', 0).attr('y1', this.dim.marginTop).attr('y2', this.dim.plotAreaHeight);
			}

			indexOfMidnight = hours.indexOf(0, indexOfMidnight + 1);
		}
	};

	HourlyChart.prototype._renderSectionSeparators = function _renderSectionSeparators() {
		var _this3 = this;

		var yCoords = [

		// rain/temperature separator
		this.dim.plotAreaHeight - this.dim.rainSectionHeight - 0.5 * this.dim.sectionSpacing,

		// temperature/wind separator
		this.dim.windSectionHeight + 0.5 * this.dim.sectionSpacing];

		yCoords.forEach(function (y) {
			_this3.elements.plotArea.append('line').attr('class', 'region_separator').attr('transform', 'translate(0,' + y + ')').attr('x1', 0).attr('x2', _this3.dim.plotAreaWidth).attr('y1', 0).attr('y2', 0);
		});
	};

	HourlyChart.prototype._renderRainfall = function _renderRainfall() {
		var _this4 = this;

		// The rain scale. Leave space at top for labels.
		// Set a lowest maximum value for the scale.
		var lowestRainScaleMax = Object(graph_limits["a" /* getLowestMaxRainAxisValue */])(this.units.rain);

		var rainScale = Object(d3_scale_src["scaleLinear"])().range([0, this.dim.rainSectionHeight - 30]).domain([0, Math.max(lowestRainScaleMax, Object(src["max"])(this.data.map(function (d) {
			return d.hourlyRainfall;
		})))]).clamp(true);

		var rainSection = this.elements.plotArea.append('g').attr('class', 'rain_section');

		var getRainBarColour = Object(interpolators["a" /* getRainColourInterpolator */])(Object(unit_converters["b" /* convertRainfall */])(15, this.units.rain));

		var validNonZeroData = this.data.filter(function (d) {
			return d.hourlyRainfall !== _this4.missingValue && d.hourlyRainfall > 0;
		});

		// Create rainfall bars for dates with a positive rainfall value.
		rainSection.selectAll('rain-bar').data(validNonZeroData, this.keyFn).enter().append('rect').attr('class', 'rain_bar').style('fill', function (d) {
			return getRainBarColour(d.hourlyRainfall, _this4.units.rain);
		}).attr('x', function (d) {
			return _this4.xScale(d.key) + 0.15 * _this4.dim.pointWidth;
		}).attr('y', function (d) {
			return _this4.dim.plotAreaHeight - rainScale(d.hourlyRainfall);
		}).attr('width', 0.7 * this.dim.pointWidth).attr('height', function (d) {
			return rainScale(d.hourlyRainfall);
		});

		// Insert the bar labels. For zero rainfall, insert a small dot instead, and increase its font size.
		rainSection.selectAll('rain-label').data(this.data, this.keyFn).enter().append('text').attr('class', 'rain_label').attr('text-anchor', 'middle').attr('x', function (d) {
			return _this4.xScale(d.key) + 0.5 * _this4.dim.pointWidth;
		}).attr('y', function (d) {
			var r = d.hourlyRainfall === _this4.missingValue ? 0 : d.hourlyRainfall;
			return _this4.dim.plotAreaHeight - rainScale(r) - 8;
		}).style('font-size', function (d) {
			return d.hourlyRainfall === 0 ? '15px' : '';
		}).text(function (d) {
			if (d.hourlyRainfall > 0) {
				return Object(formatters["e" /* formatRainfall */])(d.hourlyRainfall, _this4.units.rain, true);
			}
			return d.hourlyRainfall === 0 ? '.' : _this4.naText;
		});
	};

	HourlyChart.prototype._renderTemperature = function _renderTemperature() {
		var _this5 = this;

		// The temperature scale
		var tempScale = Object(d3_scale_src["scaleLinear"])().range([this.dim.plotAreaHeight - this.dim.rainSectionHeight - this.dim.sectionSpacing, this.dim.windSectionHeight + this.dim.sectionSpacing]);

		// Calculate the range of the unadjusted data.
		var validTemps = this.data.map(function (d) {
			return d.temperature;
		}).filter(function (t) {
			return t !== _this5.missingValue;
		});

		var tempScaleLimits = Object(src["extent"])(validTemps);
		var tempScaleRange = tempScaleLimits[1] - tempScaleLimits[0];

		// Pad out the temperature axis limits, more so at the top.
		// If there is no variation throughout the period, use +/- 1 degree
		tempScaleLimits[0] = Math.floor(tempScaleLimits[0]) - Math.max(1, 0.15 * tempScaleRange);
		tempScaleLimits[1] = Math.ceil(tempScaleLimits[1]) + Math.max(1, 0.25 * tempScaleRange);

		// Set the domain of the temperature scale
		tempScale.domain(tempScaleLimits);

		// D3 line function for calculating temperature path coordinates
		var temperatureLine = Object(d3_shape_src["line"])().x(function (d) {
			return _this5.xScale(d.key) + 0.5 * _this5.dim.pointWidth;
		}).y(function (d) {
			return tempScale(d.temperature);
		}).defined(function (d) {
			return d.temperature !== _this5.missingValue;
		});

		var getTemperatureColour = Object(interpolators["b" /* getTemperatureColourInterpolator */])(false, this.units.temperature);

		var tempSection = this.elements.plotArea.append('g').attr('class', 'temperature_section');

		// Draw the temperature line
		tempSection.append('path').attr('class', 'temperature_path').attr('d', temperatureLine(this.data));

		// Draw the temperature labels
		tempSection.selectAll('temperature-label').data(this.data, this.keyFn).enter().append('text').attr('class', 'temperature_label').attr('x', function (d) {
			return _this5.xScale(d.key) + 0.5 * _this5.dim.pointWidth;
		}).attr('y', function (d) {
			return tempScale(d.temperature);
		}).attr('dy', '0.35em').attr('text-anchor', 'middle').style('fill', function (d) {
			return d.temperature !== _this5.missingValue ? getTemperatureColour(d.temperature) : 'none';
		}).text(function (d) {
			return d.temperature !== _this5.missingValue ? d.temperature : '';
		});
	};

	HourlyChart.prototype._renderWind = function _renderWind() {
		var _this6 = this;

		var isTooNarrowForArrows = this.dim.plotAreaWidth < 750;
		var getWindColour = Object(interpolators["c" /* getWindColourInterpolator */])(this.units.speed);

		var windSection = this.elements.plotArea.append('g').attr('class', 'wind_section');

		var validGustData = this.data.filter(function (d) {
			return d.hourlyHighWindGust !== _this6.missingValue;
		});
		var nonZeroGustBearingData = validGustData.filter(function (d) {
			return d.windBearing !== _this6.missingValue && d.hourlyHighWindGust > 0;
		});

		// Draw the arrows with <use> elements. They need to be rotated according to the
		// wind direction at a particular point.
		windSection.append('g').attr('class', 'wind_symbols').selectAll('wind-symbol').data(validGustData, this.keyFn).enter().append('use').attr('xlink:href', '#wind-symbol').attr('transform', function (d) {
			return 'translate(' + (_this6.xScale(d.key) + 0.5 * _this6.dim.pointWidth - 0.5 * _this6.dim.windSymbolSize) + ',35)';
		}).style('fill', function (d) {
			return getWindColour(d.hourlyHighWindGust, _this6.units.speed);
		});

		if (!isTooNarrowForArrows) {
			windSection.append('g').attr('class', 'wind_arrows').selectAll('wind-indicator').data(nonZeroGustBearingData, this.keyFn).enter().append('use').attr('xlink:href', '#wind-arrow').attr('transform', function (d) {
				var x = _this6.xScale(d.key) + 0.5 * _this6.dim.pointWidth;
				var rotate = 45 * Math.round(d.windBearing / 45);
				var rotateCenter = 0.5 * _this6.dim.windSymbolSize;
				return 'translate(' + (x - rotateCenter) + ',35) rotate(' + rotate + ' ' + rotateCenter + ' ' + rotateCenter + ')';
			});
		}

		// Draw the wind speed labels
		windSection.append('g').attr('class', 'wind_speed_labels').selectAll('wind-speed-label').data(this.data, this.keyFn).enter().append('text').attr('class', function (d) {
			return d.hourlyHighWindGust === _this6.missingValue ? 'na_label' : null;
		}).attr('x', function (d) {
			return _this6.xScale(d.key) + 0.5 * _this6.dim.pointWidth;
		}).attr('y', 65).attr('text-anchor', 'middle').text(function (d) {
			return d.hourlyHighWindGust === _this6.missingValue ? _this6.naText : Object(formatters["h" /* formatWindGust */])(d.hourlyHighWindGust, _this6.units.speed, true, true);
		});

		// Draw the wind direction labels, directly above the wind speed labels
		windSection.append('g').attr('class', 'wind_direction_labels').selectAll('wind-direction-label').data(this.data, this.keyFn).enter().append('text').attr('x', function (d) {
			return _this6.xScale(d.key) + 0.5 * _this6.dim.pointWidth;
		}).attr('y', 35).attr('text-anchor', 'middle').text(function (d) {
			return d.windBearing === _this6.missingValue || d.hourlyHighWindGust === 0 ? '' : Object(convert_wind_bearing["b" /* convertWindBearing8 */])(d.windBearing);
		});
	};

	HourlyChart.prototype._renderLabels = function _renderLabels() {
		var _this7 = this;

		var labels = [{
			y: this.dim.plotAreaHeight - this.dim.rainSectionHeight - 0.5 * this.dim.sectionSpacing,
			text: 'Rainfall (' + this.units.rain + ')'
		}, {
			y: this.dim.windSectionHeight + 0.5 * this.dim.sectionSpacing,
			text: 'Temperature (\xB0' + this.units.temperature + ')'
		}, {
			y: -5,
			text: 'Avg wind direction, Highest gust (' + this.units.speed + ')'
		}];

		labels.forEach(function (label) {
			_this7.elements.plotArea.append('text').attr('class', 'parameter_label').attr('x', 2).attr('y', label.y).attr('dy', '1.3em').text(label.text);
		});

		var validRainfalls = this.data.map(function (d) {
			return d.hourlyRainfall;
		}).filter(function (r) {
			return r !== _this7.missingValue;
		});

		var total = validRainfalls.length === 0 ? 'n/a' : this.rainFormatter(Object(src["sum"])(validRainfalls));

		// Draw rain total label at top-right of rain region
		// Remember to filter for NA values before summing!
		this.elements.plotArea.append('text').attr('class', 'rain_total_label').attr('x', this.dim.plotAreaWidth - 5).attr('y', this.dim.plotAreaHeight - this.dim.rainSectionHeight - 0.5 * this.dim.sectionSpacing).attr('text-anchor', 'end').attr('dy', '1.3em').text('Total: ' + total);
	};

	HourlyChart.prototype._renderAxis = function _renderAxis() {
		var _this8 = this;

		var xAxis = Object(d3_axis_src["axisBottom"])().scale(this.xScale).tickSizeOuter(0).tickSizeInner(0).tickFormat(function (t, i) {

			var timeString = _this8.data[i].timestamp;
			var timePart = timeString.split(' ')[1];

			if (timePart === '23:59:59') {
				return '12am';
			}

			var hour = Number(timePart.split(':')[0]);

			if (hour % 2) {
				return '';
			}
			if (hour > 12) {
				return hour - 12 + 'pm';
			}
			if (hour === 12) {
				return '12pm';
			}

			if (hour === 0) {
				hour = 12;
			}

			return hour + 'am';
		});

		// Draw the x axis and labels
		this.elements.plotArea.append('g').attr('class', 'axis').attr('id', 'main-x-axis').attr('transform', 'translate(0,' + this.dim.plotAreaHeight + ')').call(xAxis).selectAll('text').attr('dy', '1.4em');
	};

	return HourlyChart;
}();

/* harmony default export */ var hourly_chart = (hourly_chart_HourlyChart);
// CONCATENATED MODULE: ./components/hourly-chart/index.js


function components_hourly_chart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function hourly_chart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function hourly_chart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The HourlyChartWrapper component is a wrapper around an HourlyChart instance, which renders
 * a chart to the DOM outside of Preact control.
 *
 * NOTE: data passed down is already converted into the units set by the user.
 *
 * props:
 * - data: The data set for the hourly chart. An array of objects, each containing hourly observation data
 * - w: The window width (pixels)
 */

var hourly_chart_HourlyChartWrapper = function (_Component) {
	hourly_chart__inherits(HourlyChartWrapper, _Component);

	function HourlyChartWrapper(props, context) {
		components_hourly_chart__classCallCheck(this, HourlyChartWrapper);

		var _this = hourly_chart__possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.units = context.userSettings.units;
		_this.container = null;
		_this.chart = null;
		return _this;
	}

	HourlyChartWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		// Component should not update, instead when new props are received
		// we will redraw the chart manually.
		return false;
	};

	HourlyChartWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		// Redraw the chart if the data has changed of the w parameter (window width)
		// changed. As a performance optimisation, only recreate the chart instance
		// if the data itself changed.
		if (nextProps.data !== this.props.data) {
			this.chart = new hourly_chart(nextProps.data, this.units);
		}
		if (nextProps.data !== this.props.data || nextProps.w !== this.props.w) {
			this.chart.render(this.container);
		}
	};

	HourlyChartWrapper.prototype.componentDidMount = function componentDidMount() {
		// When the component is first mounted, create a chart instance and render it.
		this.chart = new hourly_chart(this.props.data, this.units);
		this.chart.render(this.container);
	};

	HourlyChartWrapper.prototype.render = function render(props) {
		var _this2 = this;

		return Object(preact_min["h"])('div', { 'class': 'hw_hourly_chart', ref: function ref(el) {
				_this2.container = el;
			} });
	};

	return HourlyChartWrapper;
}(preact_min["Component"]);

/* harmony default export */ var components_hourly_chart = (hourly_chart_HourlyChartWrapper);
// EXTERNAL MODULE: ./components/size-aware/index.js
var size_aware = __webpack_require__("ZnYl");

// EXTERNAL MODULE: ./components/handle-loading-and-error/index.js + 1 modules
var handle_loading_and_error = __webpack_require__("/zgt");

// EXTERNAL MODULE: ./components/no-data/index.js
var no_data = __webpack_require__("FE+1");

// CONCATENATED MODULE: ./components/hourly-observations/index.js
var hourly_observations__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function hourly_observations__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function hourly_observations__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function hourly_observations__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/**
 * The HourlyObservations component is a wrapper around the HourlyChartWrapper and HourlyList
 * components. It switches which one is rendered based on the device screen width.
 *
 * props:
 * - data: The hourly observations data - an array of objects, each containing observation data
 * - listAlwaysExpanded: Should the hourly list be expanded
 * - listDescending: should the list be in descending order
 */

var _ref = Object(preact_min["h"])(no_data["a" /* NoData */], { message: 'No Hourly Observations Data Available' });

var hourly_observations_HourlyObservations = function (_Component) {
	hourly_observations__inherits(HourlyObservations, _Component);

	function HourlyObservations() {
		hourly_observations__classCallCheck(this, HourlyObservations);

		return hourly_observations__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	HourlyObservations.prototype.componentDidMount = function componentDidMount() {
		if (typeof this.props.mounted === 'function') {
			this.props.mounted();
		}
	};

	HourlyObservations.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		// Component should not update, instead when new props are received
		// we will redraw the chart manually.
		return nextProps.data !== this.props.data || nextProps.windowWidth !== this.props.windowWidth && !(nextProps.windowWidth < 720 && this.props.windowWidth < 720) || nextProps.listAlwaysExpanded !== this.props.listAlwaysExpanded || nextProps.listDescending !== this.props.listDescending;
	};

	HourlyObservations.prototype.render = function render(props, state, context) {

		if (props.data.length === 0) {
			return _ref;
		}

		var renderList = props.windowWidth < 768 || context.userSettings.ui.alwaysDisplayRecentObsAsList;

		var data = void 0;

		if (props.data) {

			data = props.data.map(function (row) {
				return hourly_observations__extends({}, row, {

					temperature: row.temperature === null ? null : Math.round(Object(unit_converters["c" /* convertTemperature */])(row.temperature, context.userSettings.units.temperature)),

					hourlyHighWindGust: row.hourlyHighWindGust === null ? null : Object(unit_converters["e" /* convertWindSpeed */])(row.hourlyHighWindGust, context.userSettings.units.speed),

					hourlyRainfall: row.hourlyRainfall === null ? null : Object(unit_converters["b" /* convertRainfall */])(row.hourlyRainfall, context.userSettings.units.rain)

				});
			});
		} else {

			data = props.data;
		}

		return renderList ? Object(preact_min["h"])(hourly_list, { data: data, alwaysExpanded: props.listAlwaysExpanded, descending: props.listDescending }) : Object(preact_min["h"])(components_hourly_chart, { data: data, w: props.windowWidth });
	};

	return HourlyObservations;
}(preact_min["Component"]);

/* harmony default export */ var hourly_observations = __webpack_exports__["a"] = (Object(handle_loading_and_error["a" /* default */])(Object(size_aware["a" /* default */])(hourly_observations_HourlyObservations)));

/***/ }),

/***/ "wPJI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"direction_labels":"direction_labels__34ZlS","outline":"outline__34vUN","current_speed":"current_speed__5glIw","direction_arrow":"direction_arrow__VMS4I"};

/***/ }),

/***/ "yCrg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/d3-scale/src/index.js + 38 modules
var src = __webpack_require__("zL2z");

// EXTERNAL MODULE: ../node_modules/d3-array/src/index.js + 31 modules
var d3_array_src = __webpack_require__("K0bd");

// EXTERNAL MODULE: ../node_modules/d3-selection/src/index.js + 50 modules
var d3_selection_src = __webpack_require__("//ys");

// EXTERNAL MODULE: ../node_modules/d3-transition/src/index.js + 32 modules
var d3_transition_src = __webpack_require__("UqVV");

// EXTERNAL MODULE: ./utils/convert-wind-bearing.js
var convert_wind_bearing = __webpack_require__("Dqzv");

// EXTERNAL MODULE: ./utils/interpolators.js
var interpolators = __webpack_require__("VqWv");

// EXTERNAL MODULE: ./components/rain-drop/index.js
var rain_drop = __webpack_require__("6hGj");

// EXTERNAL MODULE: ./components/button/index.js
var components_button = __webpack_require__("rAoZ");

// EXTERNAL MODULE: ./utils/formatters.js
var formatters = __webpack_require__("gNwm");

// EXTERNAL MODULE: ./components/daily-list/style.scss
var style = __webpack_require__("SPD/");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./utils/unit-converters.js
var unit_converters = __webpack_require__("rbCG");

// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__("hafV");

// CONCATENATED MODULE: ./components/daily-list/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















/**
 * The DailyList component displays a list of daily records, in a vertical arrangement.
 * It is used instead of the DailyChartWrapper component on smaller screens where there is
 * insufficient width to draw a chart.
 *
 * NOTE: data passed down is already converted into the units set by the user.
 *
 * props:
 * - data: An array of objects, each containing daily record data
 * - descending: optional - set to true to sort in descending order
 */

var daily_list_DailyList = function (_Component) {
	_inherits(DailyList, _Component);

	function DailyList(props, context) {
		_classCallCheck(this, DailyList);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.units = context.userSettings.units;
		_this.isExpandedByDefault = context.userSettings.ui.dailyListExpanded;

		_this.getWindColour = Object(interpolators["c" /* getWindColourInterpolator */])(_this.units.speed);
		_this.getRainColour = Object(interpolators["a" /* getRainColourInterpolator */])(Object(unit_converters["b" /* convertRainfall */])(50, _this.units.rain));

		_this.state = {
			isExpanded: _this.isExpandedByDefault
		};

		// keep track of temperature bar transitions, so they don't repeat when list expanded/collapsed
		_this.temperatureBarTransitions = {};

		_this.formatters = {
			date: Object(formatters["j" /* getDateTimeFormatConverter */])('%Y-%m-%d', '%-d %b'),
			rainfall: function rainfall(r) {
				return Object(formatters["e" /* formatRainfall */])(r, _this.units.rain, true);
			}
		};

		_this.toggleNumItems = _this.toggleNumItems.bind(_this);
		return _this;
	}

	DailyList.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		// When the data changes, reset the transition states
		if (nextProps.data !== this.props.data) {
			this.temperatureBarTransitions = {};
		}
	};

	DailyList.prototype.render = function render(props) {
		var _this2 = this;

		if (!Array.isArray(props.data)) {
			return null;
		}

		var formattedData = this.formatData(props.data);

		if (props.descending) {
			formattedData.reverse(); // display most recent at the top
		}

		formattedData.forEach(function (d) {
			if (_this2.temperatureBarTransitions[d.date] === undefined) {
				_this2.temperatureBarTransitions[d.date] = false;
			}
		});

		// This scale will define the horizontal positions of the temperature bars
		this.tempScale = Object(src["scaleLinear"])().range([0, 100]).domain(Object(d3_array_src["extent"])([].concat(formattedData.map(function (d) {
			return d.highTemperature;
		})).concat(formattedData.map(function (d) {
			return d.lowTemperature;
		}))));

		return Object(preact_min["h"])(
			'div',
			null,
			Object(preact_min["h"])(
				'ul',
				{ 'class': style_default.a.daily_list },
				Object(preact_min["h"])(
					'li',
					{ 'class': style_default.a.daily_list_head, key: 'labels' },
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.daily_list_date_column },
						'Date'
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.daily_list_temp_column },
						'Min/max (\xB0',
						this.units.temperature,
						')'
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.daily_list_rain_column },
						'Rain (',
						this.units.rain,
						')'
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.daily_list_gust_column },
						'Gust (',
						this.units.speed,
						')'
					)
				),
				formattedData.slice(0, this.isExpanded() ? formattedData.length : 12).map(function (ob) {
					return Object(preact_min["h"])(
						'li',
						{ 'class': style_default.a.daily_list_row, key: ob.key },
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.daily_list_date_column },
							ob.date
						),
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.daily_list_temp_column },
							ob.empty ? '---' : _this2.renderTemperature(ob)
						),
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.daily_list_rain_column },
							ob.empty ? '---' : _this2.renderRain(ob)
						),
						Object(preact_min["h"])(
							'div',
							{ 'class': style_default.a.daily_list_gust_column },
							ob.empty ? '---' : _this2.renderWind(ob)
						)
					);
				})
			),
			this.isExpanded() ? Object(preact_min["h"])(
				'p',
				{ 'class': style_default.a.daily_list_note },
				'Rain Total = ',
				this.formatters.rainfall(this.getRainTotal()) + ' ' + this.units.rain
			) : null,
			this.renderToggleButton()
		);
	};

	DailyList.prototype.renderToggleButton = function renderToggleButton() {
		if (this.props.alwaysExpanded) {
			return null;
		}

		return Object(preact_min["h"])(
			components_button["a" /* default */],
			{ wide: true, clickHandler: this.toggleNumItems },
			this.isExpanded() ? 'Show less' : 'Show more'
		);
	};

	DailyList.prototype.renderRain = function renderRain(ob) {
		return Object(preact_min["h"])(
			'span',
			{ 'class': style_default.a.daily_list_rain_cell },
			ob.rainfall === null ? 'n/a' : ob.rainfall > 0 ? this.formatters.rainfall(ob.rainfall) : '.',
			Object(preact_min["h"])(
				'span',
				{ 'class': style_default.a.daily_list_raindrop },
				ob.rainfall !== null && ob.rainfall > 0 ? Object(preact_min["h"])(rain_drop["a" /* default */], { fill: this.getRainColour(ob.rainfall, this.units.rain),
					size: this.getRainDropSize(ob.rainfall) }) : null
			)
		);
	};

	DailyList.prototype.getRainTotal = function getRainTotal() {
		return Object(d3_array_src["sum"])(this.props.data.filter(function (d) {
			return !d.empty && d.rainfall !== null;
		}).map(function (d) {
			return d.rainfall;
		}));
	};

	DailyList.prototype.renderWind = function renderWind(ob) {
		if (ob.highWindGust !== null) {
			return Object(preact_min["h"])(
				'span',
				{ 'class': style_default.a.daily_list_wind_gust_cell },
				Object(preact_min["h"])(
					'span',
					{ 'class': style_default.a.daily_list_wind_gust_dir },
					ob.highWindGustDirection
				),
				Object(preact_min["h"])(
					'span',
					{ 'class': style_default.a.daily_list_wind_gust_value },
					Object(preact_min["h"])(
						'span',
						{ 'class': style_default.a.daily_list_wind_cell,
							style: { backgroundColor: this.getWindColour(ob.highWindGust, this.units.speed) } },
						Object(formatters["h" /* formatWindGust */])(ob.highWindGust, this.units.speed, true, true)
					)
				)
			);
		}
		return 'n/a';
	};

	DailyList.prototype.renderTemperature = function renderTemperature(ob) {
		var _this3 = this;

		var avgX = ob.avgTemperature === null ? 0.5 * Object(d3_array_src["sum"])(this.tempScale.range()) : this.tempScale(ob.avgTemperature);

		var lowBarLeft = ob.lowTemperature === null ? avgX : this.tempScale(ob.lowTemperature);

		var lowBarWidth = ob.lowTemperature === null || ob.avgTemperature === null ? 0 : avgX - lowBarLeft;

		var highBarLeft = avgX;

		var highBarWidth = ob.highTemperature === null || ob.avgTemperature === null ? 0 : this.tempScale(ob.highTemperature) - highBarLeft;

		return Object(preact_min["h"])(
			'div',
			{ 'class': style_default.a.daily_list_temp_cell },
			Object(preact_min["h"])(
				'span',
				{ 'class': style_default.a.daily_list_temp_label_low,
					style: { right: 100 - lowBarLeft + '%' } },
				ob.lowTemperature === null ? 'n/a' : ob.lowTemperature
			),
			Object(preact_min["h"])('span', { 'class': style_default.a.daily_list_temp_bar_low,
				style: { right: 100 - highBarLeft + '%' },
				ref: function ref(el) {
					return el && _this3.transitionWidth(el, ob.date, lowBarWidth);
				} }),
			Object(preact_min["h"])('span', { 'class': style_default.a.daily_list_temp_bar_high,
				style: { left: highBarLeft + '%' },
				ref: function ref(el) {
					return el && _this3.transitionWidth(el, ob.date, highBarWidth);
				} }),
			Object(preact_min["h"])(
				'span',
				{ 'class': style_default.a.daily_list_temp_label_high,
					style: { left: highBarLeft + highBarWidth + '%' } },
				ob.highTemperature === null ? 'n/a' : ob.highTemperature
			)
		);
	};

	DailyList.prototype.transitionWidth = function transitionWidth(el, key, width) {
		var _this4 = this;

		var d3Elem = Object(d3_selection_src["select"])(el);

		if (this.temperatureBarTransitions[key] === false) {
			// Transition has not been run for this date yet within this component instance,
			// so animate the width.
			d3Elem.transition().duration(500).styleTween('width', function () {
				return function (t) {
					return t * width + '%';
				};
			}).on('end', function () {
				_this4.temperatureBarTransitions[key] = true;
			});
		} else {
			// Transition has already been run. Set the width immediately, don't animate it.
			d3Elem.style('width', width + '%');
		}
	};

	DailyList.prototype.isExpanded = function isExpanded() {
		return this.props.alwaysExpanded || this.state.isExpanded;
	};

	DailyList.prototype.toggleNumItems = function toggleNumItems() {
		this.setState(function (state) {
			return { isExpanded: !state.isExpanded };
		});
	};

	DailyList.prototype.getRainDropSize = function getRainDropSize(rain) {
		var rainMm = this.units.rain === constants["f" /* RAIN_UNIT */].IN ? rain * 25.4 : rain;
		return Math.min(32, 10 + 0.5 * rainMm);
	};

	DailyList.prototype.formatData = function formatData(data) {
		var _this5 = this;

		return data.map(function (ob, index) {

			var date = _this5.formatters.date(ob.date);

			var highWindGustDirection = ob.highWindGustBearing === null ? null : ob.highWindGust > 0 ? Object(convert_wind_bearing["b" /* convertWindBearing8 */])(ob.highWindGustBearing) : '-';

			return _extends({}, ob, {
				date: date,
				highWindGustDirection: highWindGustDirection,
				key: index
			});
		});
	};

	return DailyList;
}(preact_min["Component"]);

/* harmony default export */ var daily_list = (daily_list_DailyList);
// EXTERNAL MODULE: ../node_modules/d3-shape/src/index.js + 51 modules
var d3_shape_src = __webpack_require__("9maw");

// EXTERNAL MODULE: ../node_modules/d3-axis/src/index.js + 3 modules
var d3_axis_src = __webpack_require__("mp0m");

// EXTERNAL MODULE: ../node_modules/d3-time-format/src/index.js + 4 modules
var d3_time_format_src = __webpack_require__("UYpZ");

// CONCATENATED MODULE: ./utils/daily-chart.js
function daily_chart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }















var daily_chart_DailyChart = function () {
	function DailyChart(data, units) {
		daily_chart__classCallCheck(this, DailyChart);

		this.data = data;
		this.units = units;
		this.naText = 'n/a';
		this.missingValue = null;
		this.dateFormat = '%Y-%m-%d';

		this.dim = {
			marginTop: 10,
			marginRight: 10,
			marginBottom: 30,
			marginLeft: 10,

			regionSpacing: 30,
			windRegionHeight: 70,
			rainRegionHeightProp: 0.35,
			tempRegionHeightProp: 0.65,

			windSize: 50
		};

		this.keyFn = function (d) {
			return d.date;
		};
	}

	DailyChart.prototype.render = function render(containerNode) {

		this._init(containerNode);
		this._renderSeparators();
		this._createWindIndicatorDefs();
		this._renderWindSection();
		this._renderTemperatureSection();
		this._renderRainSection();
		this._renderAxis();
		this._setupCursor();
	};

	DailyChart.prototype._init = function _init(containerNode) {

		var containerDim = containerNode.getBoundingClientRect();

		this.dim.width = containerDim.width;
		this.dim.height = 420;

		// If available width is too small, certain things will need adjusting
		this.isSmall = this.dim.width < 800;
		this.dim.windCircleRadius = this.isSmall ? 11 : 13;

		// Calculate dimensions of actual plot area
		this.dim.plotAreaWidth = this.dim.width - this.dim.marginLeft - this.dim.marginRight;
		this.dim.plotAreaHeight = this.dim.height - this.dim.marginTop - this.dim.marginBottom;

		var remainingHeight = this.dim.height - this.dim.marginTop - this.dim.marginBottom - 2 * this.dim.regionSpacing - this.dim.windRegionHeight;

		this.dim.rainRegionHeight = remainingHeight * this.dim.rainRegionHeightProp;
		this.dim.tempRegionHeight = remainingHeight * this.dim.tempRegionHeightProp;

		// The x scale. Make sure there is good spacing between points.
		this.xScale = Object(src["scaleBand"])().domain(this.data.map(this.keyFn)).rangeRound([0, this.dim.plotAreaWidth]).paddingInner(0.25).paddingOuter(0).paddingOuter(0);

		var container = Object(d3_selection_src["select"])(containerNode);
		container.html('');

		// Insert the SVG element and apply the margins
		this.svg = container.append('svg').attr('width', this.dim.width).attr('height', this.dim.height);

		// Get the SVG context we will be drawing in (simply applies the margins).
		this.plotArea = this.svg.append('g').attr('class', 'hw_daily_chart_plot_area').attr('transform', 'translate(' + this.dim.marginLeft + ',' + this.dim.marginTop + ')').attr('pointer-events', 'none');

		// Background rect for whole plot area
		this.eventCapturingBox = this.plotArea.append('rect').attr('class', 'hw_daily_chart_event_capturing_box').attr('x', 0).attr('y', 0).attr('width', this.dim.plotAreaWidth).attr('height', this.dim.plotAreaHeight);
	};

	DailyChart.prototype._setupCursor = function _setupCursor() {
		var _this = this;

		// A cursor is a vertical line to help users line up observations in the different vertical
		// sections of the chart. It moves with the mouse pointer, or on touch screens if moves with
		// the touch location on the screen.

		var cursor = this.plotArea.append('line').attr('class', 'cursor').attr('x1', 0).attr('x2', 0).attr('y1', this.dim.marginTop).attr('y2', this.dim.plotAreaHeight);

		var hideCursor = function hideCursor() {
			return cursor.style('stroke-opacity', 0);
		};
		var showCursor = function showCursor() {
			return cursor.style('stroke-opacity', 0.8);
		};
		var positionCursor = function positionCursor(x) {
			return cursor.attr('x1', x).attr('x2', x);
		};

		this.eventCapturingBox.on('mouseover', showCursor);
		this.eventCapturingBox.on('mouseout', hideCursor);

		this.eventCapturingBox.on('mousemove', function () {
			var position = Object(d3_selection_src["mouse"])(_this.plotArea.node());
			positionCursor(position[0]);
		});

		var setCursorPositionTouch = function setCursorPositionTouch() {
			var position = Object(d3_selection_src["touches"])(_this.plotArea.node())[0];
			positionCursor(position[0]);
		};

		this.eventCapturingBox.on('touchstart', function () {
			showCursor();
			setCursorPositionTouch();
		});

		this.eventCapturingBox.on('blur', hideCursor);
		this.eventCapturingBox.on('touchmove', setCursorPositionTouch);
	};

	DailyChart.prototype._createWindIndicatorDefs = function _createWindIndicatorDefs() {

		// Create definitions for wind icons & arrows
		var defs = this.svg.append('defs');

		var windSymbol = defs.append('g').attr('id', 'wind-icon');

		// Use circle shape
		windSymbol.append('circle').attr('cx', 0.5 * this.dim.windSize).attr('cy', 0.5 * this.dim.windSize).attr('r', this.dim.windCircleRadius);

		var y0 = 0.5 * this.dim.windSize - this.dim.windCircleRadius + 4;
		var length = 8;
		var y1 = y0 - length;
		var x0 = 0.5 * (this.dim.windSize - length * 1.2);
		var x1 = 0.5 * (this.dim.windSize + length * 1.2);

		defs.append('g').attr('id', 'wind-indicator').append('path').attr('d', 'M' + x0 + ',' + y1 + ' L' + x1 + ',' + y1 + ' L' + 0.5 * this.dim.windSize + ',' + y0 + ' L' + x0 + ',' + y1);
	};

	DailyChart.prototype._renderWindSection = function _renderWindSection() {
		var _this2 = this;

		// Draw the arrows with <use> elements. They need to be rotated according to the
		// wind direction at a particular point.

		var windInterpolator = Object(interpolators["c" /* getWindColourInterpolator */])(this.units.speed);
		var windRegion = this.plotArea.append('g').attr('class', 'wind_section');
		var y = 35;

		var validGustData = this.data.filter(function (d) {
			return !d.empty && d.highWindGust !== _this2.missingValue;
		});
		var validBearingData = this.data.filter(function (d) {
			return !d.empty && d.highWindGustBearing !== _this2.missingValue;
		});
		var nonZeroGustBearingData = validBearingData.filter(function (d) {
			return !d.empty && d.highWindGust !== null && d.highWindGust > 0;
		});

		windRegion.append('g').attr('class', 'wind_icons').selectAll('use').data(validGustData, this.keyFn).enter().append('use').attr('xlink:href', '#wind-icon').attr('transform', function (d) {
			var transX = _this2.xScale(d.date) + 0.5 * _this2.xScale.bandwidth();
			return 'translate(' + (transX - 0.5 * _this2.dim.windSize) + ',' + y + ')';
		}).style('fill', function (d) {
			return windInterpolator(d.highWindGust);
		});

		// Draw wind indicators
		if (this.dim.width > 900) {
			windRegion.append('g').attr('class', 'wind_arrows').selectAll('use').data(nonZeroGustBearingData, this.keyFn).enter().append('use').attr('xlink:href', '#wind-indicator').attr('transform', function (d) {
				var transX = _this2.xScale(d.date) + 0.5 * _this2.xScale.bandwidth();
				var rotate = 45 * Math.round(d.highWindGustBearing / 45);
				return 'translate(' + (transX - 0.5 * _this2.dim.windSize) + ',35) rotate(' + rotate + ' ' + 0.5 * _this2.dim.windSize + ' ' + 0.5 * _this2.dim.windSize + ')';
			});
		}

		// Draw the labels for wind direction and speed
		windRegion.append('g').attr('class', 'wind_gust_labels').selectAll('text.wind_gust_label').data(this.data, this.keyFn).enter().append('text').attr('class', function (d) {
			return d.empty || d.highWindGust === _this2.missingValue ? 'missing_label' : null;
		}).attr('x', function (d) {
			return _this2.xScale(d.date) + 0.5 * _this2.xScale.bandwidth();
		}).attr('y', y + 0.5 * this.dim.windSize).attr('dy', '0.35em').attr('text-anchor', 'middle').text(function (d) {
			return d.empty || d.highWindGust === _this2.missingValue ? _this2.naText : Object(formatters["h" /* formatWindGust */])(d.highWindGust, _this2.units.speed, true, true);
		});

		windRegion.append('g').attr('class', 'wind_direction_labels').selectAll('text.wind_direction_label').data(nonZeroGustBearingData, this.keyFn).enter().append('text').attr('x', function (d) {
			return _this2.xScale(d.date) + 0.5 * _this2.xScale.bandwidth();
		}).attr('y', y).attr('text-anchor', 'middle').text(function (d) {
			return Object(convert_wind_bearing["b" /* convertWindBearing8 */])(d.highWindGustBearing);
		});

		// Draw wind label in top left of wind region
		windRegion.append('text').attr('class', 'section_label').attr('x', 5).attr('y', 5).attr('dy', '0.8em').text('Peak wind gust (' + this.units.speed + ')');
	};

	DailyChart.prototype._renderTemperatureSection = function _renderTemperatureSection() {
		var _this3 = this;

		// The temperature scale
		var tempScale = Object(src["scaleLinear"])().range([this.dim.plotAreaHeight - this.dim.rainRegionHeight - this.dim.regionSpacing, this.dim.windRegionHeight + this.dim.regionSpacing]);

		var minTemps = this.data.map(function (d) {
			return d.lowTemperature;
		}).filter(function (val) {
			return val !== _this3.missingValue;
		});

		var maxTemps = this.data.map(function (d) {
			return d.highTemperature;
		}).filter(function (val) {
			return val !== _this3.missingValue;
		});

		var tempScaleLimits = Object(d3_array_src["extent"])([].concat(minTemps).concat(maxTemps));

		if (minTemps.length === 0 && maxTemps.length === 0) {
			tempScaleLimits = [0, 20];
		}

		var tempScaleRange = tempScaleLimits[1] - tempScaleLimits[0];

		// Pad out the temperature axis limits, more so at the top.
		// If there is no variation throughout the period, use +/- 1 degree
		tempScaleLimits[0] = Math.floor(tempScaleLimits[0]) - Math.max(1, 0.15 * tempScaleRange);
		tempScaleLimits[1] = Math.ceil(tempScaleLimits[1]) + Math.max(1, 0.25 * tempScaleRange);

		// Set the domain of the temperature scale
		tempScale.domain(tempScaleLimits);

		var heightTween = function heightTween(d) {
			return function (t) {
				return t * d;
			};
		};

		var tempRegion = this.plotArea.append('g').attr('class', 'temperature_section');

		tempRegion.append('g').attr('class', 'temperature_bars_high').selectAll('rect.temperature_bar_high').data(this.data.filter(function (d) {
			return !d.empty && d.avgTemperature !== _this3.missingValue && d.highTemperature !== _this3.missingValue;
		}), this.keyFn).enter().append('rect').attr('transform', function (d) {
			return 'translate(' + _this3.xScale(d.date) + ',' + tempScale(d.avgTemperature) + ') scale(1,-1)';
		}).attr('width', this.xScale.bandwidth()).attr('height', 0).transition().duration(500).attrTween('height', function (d) {
			return heightTween(tempScale(d.avgTemperature) - tempScale(Math.round(d.highTemperature)));
		});

		tempRegion.append('g').attr('class', 'temperature_bars_low').selectAll('rect.temperature_bar_low').data(this.data.filter(function (d) {
			return !d.empty && d.avgTemperature !== _this3.missingValue && d.lowTemperature !== _this3.missingValue;
		}), this.keyFn).enter().append('rect').attr('x', function (d) {
			return _this3.xScale(d.date);
		}).attr('y', function (d) {
			return tempScale(d.avgTemperature);
		}).attr('width', this.xScale.bandwidth()).attr('height', 0).transition().duration(500).attrTween('height', function (d) {
			return heightTween(tempScale(Math.round(d.lowTemperature)) - tempScale(d.avgTemperature));
		});

		// D3 line function for calculating temperature path coordinates
		var avgTemperatureLine = Object(d3_shape_src["line"])().x(function (d) {
			return _this3.xScale(d.date) + 0.5 * _this3.xScale.bandwidth();
		}).y(function (d) {
			return tempScale(d.avgTemperature);
		}).defined(function (d) {
			return !d.empty && d.avgTemperature !== _this3.missingValue;
		}).curve(d3_shape_src["curveCatmullRom"]);

		// Draw the temperature lines
		tempRegion.append('path').attr('class', 'temperature_avg_path').attr('d', avgTemperatureLine(this.data));

		// Draw the high temperature labels
		tempRegion.append('g').attr('class', 'temperature_high_labels').selectAll('text.temperature_high_label').data(this.data.filter(function (d) {
			return !d.empty && d.highTemperature !== _this3.missingValue;
		}), this.keyFn).enter().append('text').attr('x', function (d) {
			return _this3.xScale(d.date) + 0.5 * _this3.xScale.bandwidth();
		}).attr('y', function (d) {
			return d.highTemperature === _this3.missingValue ? 0 : tempScale(Math.round(d.highTemperature));
		}).attr('dy', '-0.5em').attr('text-anchor', 'middle').text(function (d) {
			return d.highTemperature === _this3.missingValue ? '' : d.highTemperature;
		});

		// Draw the low temperature labels
		tempRegion.append('g').attr('class', 'temperature_low_labels').selectAll('text.temperature_low_label').data(this.data.filter(function (d) {
			return !d.empty && d.lowTemperature !== _this3.missingValue;
		}), this.keyFn).enter().append('text').attr('x', function (d) {
			return _this3.xScale(d.date) + 0.5 * _this3.xScale.bandwidth();
		}).attr('y', function (d) {
			return d.lowTemperature === _this3.missingValue ? 0 : tempScale(Math.round(d.lowTemperature));
		}).attr('dy', '1.2em').attr('text-anchor', 'middle').text(function (d) {
			return d.lowTemperature === _this3.missingValue ? '' : d.lowTemperature;
		});

		// Draw the temperature region and wind region separator
		tempRegion.append('line').attr('class', 'region_separator').attr('transform', 'translate(0,' + (this.dim.windRegionHeight + 0.5 * this.dim.regionSpacing) + ')').attr('x1', 0).attr('x2', this.dim.plotAreaWidth).attr('y1', 0).attr('y2', 0);

		// Draw temperature label in top left of temperature region
		tempRegion.append('text').attr('class', 'section_label').attr('x', 5).attr('y', this.dim.windRegionHeight + this.dim.regionSpacing / 2).attr('dy', '1.3em').text('High and low temperatures (\xB0' + this.units.temperature + ')');
	};

	DailyChart.prototype._renderRainSection = function _renderRainSection() {
		var _this4 = this;

		var lowestRainScaleMax = this.units.rain === constants["f" /* RAIN_UNIT */].IN ? 0.4 : 10;
		var rainDecimals = this.units.rain === constants["f" /* RAIN_UNIT */].IN ? 2 : 1;

		// Filter any NA values
		var rainTotals = this.data.map(function (d) {
			return d.rainfall;
		}).filter(function (r) {
			return r !== _this4.missingValue;
		});

		// The rain scale. Leave space at top for labels.
		var rainScale = Object(src["scaleLinear"])().range([0, this.dim.rainRegionHeight - 30]).domain([0, Math.max(lowestRainScaleMax, Object(d3_array_src["max"])(rainTotals))]).clamp(true);

		var rainInterpolator = Object(interpolators["a" /* getRainColourInterpolator */])(Object(unit_converters["b" /* convertRainfall */])(50, this.units.rain));
		var rainRegion = this.plotArea.append('g').attr('class', 'rain_section');

		// Insert the rainfall bars
		rainRegion.append('g').attr('class', 'rain_bars').selectAll('rect.rain_bar').data(this.data.filter(function (d) {
			return !d.empty && d.rainfall !== _this4.missingValue && d.rainfall > 0;
		}), this.keyFn).enter().append('rect').style('fill', function (d) {
			return rainInterpolator(d.rainfall);
		}).attr('x', function (d) {
			return _this4.xScale(d.date);
		}).attr('y', function (d) {
			return _this4.dim.plotAreaHeight - rainScale(d.rainfall);
		}).attr('width', this.xScale.bandwidth()).attr('height', function (d) {
			return rainScale(d.rainfall);
		});

		// Insert the bar labels. For zero rainfall, insert a small dot instead, and increase its font size.
		// Remember to check values are all at least 0.
		rainRegion.append('g').attr('class', 'rain_labels').selectAll('text.rain_label').data(this.data, this.keyFn).enter().append('text').attr('class', function (d) {
			if (d.rainfall === 0) {
				return 'rain_zero';
			}
			if (d.empty || d.rainfall === _this4.missingValue) {
				return 'missing_label';
			}
			return 'rain_label';
		}).attr('text-anchor', 'middle').attr('x', function (d) {
			return _this4.xScale(d.date) + 0.5 * _this4.xScale.bandwidth();
		}).attr('y', function (d) {
			if (d.empty || d.rainfall === _this4.missingValue) {
				return _this4.dim.plotAreaHeight - 8;
			}
			var r = d.rainfall === _this4.missingValue ? 0 : d.rainfall;
			return _this4.dim.plotAreaHeight - rainScale(r) - 8;
		}).text(function (d) {
			if (d.empty || d.rainfall === _this4.missingValue) {
				return _this4.naText;
			}
			if (d.rainfall > 0) {
				var precision = Math.pow(10, rainDecimals);
				var label = Math.round(precision * d.rainfall) / precision;
				// For 2 dp values, remove leading zero
				//  so labels are not too crammed together
				if (label < 0.1) {
					label = ('' + label).substring(1);
				}
				return label;
			}
			return '.';
		});

		// Draw rainfall label in top left of rain region
		rainRegion.append('text').attr('class', 'section_label').attr('x', 5).attr('y', this.dim.plotAreaHeight - this.dim.rainRegionHeight - 0.5 * this.dim.regionSpacing).attr('dy', '1.3em').text('Daily rainfall (' + this.units.rain + ')');

		// Draw rain total label at top-right of rain region
		rainRegion.append('text').attr('class', 'statistic_label').attr('x', this.dim.plotAreaWidth - 5).attr('y', this.dim.plotAreaHeight - this.dim.rainRegionHeight - 0.5 * this.dim.regionSpacing).attr('text-anchor', 'end').attr('dy', '1.3em').text('Total: ' + Object(d3_array_src["sum"])(rainTotals).toFixed(rainDecimals));

		// Add line to separate rain region from temperature region
		rainRegion.append('line').attr('class', 'region_separator').attr('transform', 'translate(0,' + (this.dim.plotAreaHeight - this.dim.rainRegionHeight - 0.5 * this.dim.regionSpacing) + ')').attr('x1', 0).attr('x2', this.dim.plotAreaWidth).attr('y1', 0).attr('y2', 0);
	};

	DailyChart.prototype._renderSeparators = function _renderSeparators() {

		// Insert day separator(s) between months. To do so, need to get the positions
		// of the two points and average them, then add half the interval width.

		var dateFormat = Object(d3_time_format_src["timeFormat"])(this.dateFormat);
		var dateParser = Object(d3_time_format_src["timeParse"])(dateFormat);

		var daysOfMonth = this.data.map(function (d) {
			return dateParser(d.date).getDate();
		});
		var numPoints = this.data.length;

		var indexOfNewMonth = daysOfMonth.indexOf(1);

		while (indexOfNewMonth !== -1) {

			if (indexOfNewMonth < numPoints && indexOfNewMonth > 0) {

				var prevMonthDate = this.data[indexOfNewMonth - 1].date;
				var currMonthDate = this.data[indexOfNewMonth].date;
				var newMonthLineX = 0.5 * (this.xScale(prevMonthDate) + this.xScale(currMonthDate) + this.xScale.bandwidth());

				this.plotArea.append('line').attr('class', 'month_separator').attr('x1', newMonthLineX).attr('x2', newMonthLineX).attr('y1', this.dim.marginTop).attr('y2', this.dim.plotAreaHeight + 20);
			}

			indexOfNewMonth = daysOfMonth.indexOf(1, indexOfNewMonth + 1);
		}
	};

	DailyChart.prototype._renderAxis = function _renderAxis() {

		// Create the x axis, with no ticks showing.
		var xAxis = Object(d3_axis_src["axisBottom"])().scale(this.xScale).tickSizeInner(0).tickSizeOuter(0).tickFormat(function (date) {
			return parseInt(date.substr(-2), 10);
		});

		// Draw the x axis and labels
		this.plotArea.append('g').attr('class', 'date_axis').attr('transform', 'translate(0,' + this.dim.plotAreaHeight + ')').call(xAxis).selectAll('text').attr('dy', '1.4em');
	};

	return DailyChart;
}();

/* harmony default export */ var daily_chart = (daily_chart_DailyChart);
// CONCATENATED MODULE: ./components/daily-chart/index.js


function components_daily_chart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function daily_chart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function daily_chart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The DailyChartWrapper component is a wrapper around a DailyChart instance, which renders
 * a chart to the DOM outside of Preact control.
 *
 * NOTE: data passed down is already converted into the units set by the user.
 *
 * props:
 * - data: The data set for the daily chart. An array of objects, each containing daily record data
 * - w: The window width (pixels)
 */

var daily_chart_DailyChartWrapper = function (_Component) {
	daily_chart__inherits(DailyChartWrapper, _Component);

	function DailyChartWrapper(props, context) {
		components_daily_chart__classCallCheck(this, DailyChartWrapper);

		var _this = daily_chart__possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.units = context.userSettings.units;
		_this.container = null;
		_this.chart = null;
		return _this;
	}

	DailyChartWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		// Component should not update, instead when new props are received
		// we will redraw the chart manually.
		return false;
	};

	DailyChartWrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		// Redraw the chart if the data has changed of the w parameter (window width)
		// changed. As a performance optimisation, only recreate the chart instance
		// if the data itself changed.
		if (nextProps.data !== this.props.data) {
			this.chart = new daily_chart(nextProps.data, this.units);
		}
		if (nextProps.data !== this.props.data || nextProps.w !== this.props.w) {
			this.chart.render(this.container);
		}
	};

	DailyChartWrapper.prototype.componentDidMount = function componentDidMount() {
		// When the component is first mounted, create a chart instance and render it.
		this.chart = new daily_chart(this.props.data, this.units);
		this.chart.render(this.container);
	};

	DailyChartWrapper.prototype.render = function render(props) {
		var _this2 = this;

		return Object(preact_min["h"])('div', { 'class': 'hw_daily_chart', ref: function ref(el) {
				_this2.container = el;
			} });
	};

	return DailyChartWrapper;
}(preact_min["Component"]);

/* harmony default export */ var components_daily_chart = (daily_chart_DailyChartWrapper);
// EXTERNAL MODULE: ./components/size-aware/index.js
var size_aware = __webpack_require__("ZnYl");

// EXTERNAL MODULE: ./components/handle-loading-and-error/index.js + 1 modules
var handle_loading_and_error = __webpack_require__("/zgt");

// EXTERNAL MODULE: ./components/no-data/index.js
var no_data = __webpack_require__("FE+1");

// CONCATENATED MODULE: ./components/daily-observations/index.js
var daily_observations__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function daily_observations__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function daily_observations__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function daily_observations__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/**
 * The DailyObservations component is a wrapper around the DailyChartWrapper and DailyList
 * components. It switches which one is rendered based on the device screen width.
 * Note that the data is transformed according to the units specified before being passed
 * down into the child list or graph component.
 *
 * props:
 * - data: The daily records data - an array of objects, each containing daily record data
 * - listAlwaysExpanded: Should the hourly list be expanded
 * - listDescending: should the list be in descending order
 */

var _ref = Object(preact_min["h"])(no_data["a" /* NoData */], null);

var daily_observations_DailyObservations = function (_Component) {
	daily_observations__inherits(DailyObservations, _Component);

	function DailyObservations() {
		daily_observations__classCallCheck(this, DailyObservations);

		return daily_observations__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	DailyObservations.prototype.componentDidMount = function componentDidMount() {
		if (typeof this.props.mounted === 'function') {
			this.props.mounted();
		}
	};

	DailyObservations.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		// Component should not update, instead when new props are received
		// we will redraw the chart manually.
		return nextProps.data !== this.props.data || nextProps.windowWidth !== this.props.windowWidth && !(nextProps.windowWidth < 720 && this.props.windowWidth < 720) || nextProps.listAlwaysExpanded !== this.props.listAlwaysExpanded || nextProps.listDescending !== this.props.listDescending;
	};

	DailyObservations.prototype.render = function render(props, state, context) {

		if (props.data && props.data.length === 0) {
			return _ref;
		}

		var renderList = props.windowWidth < 768 || context.userSettings.ui.alwaysDisplayRecentObsAsList;

		var data = void 0;

		if (props.data) {

			data = props.data.map(function (row) {
				return daily_observations__extends({}, row, {

					highTemperature: row.highTemperature === null ? null : Math.round(Object(unit_converters["c" /* convertTemperature */])(row.highTemperature, context.userSettings.units.temperature)),

					avgTemperature: row.avgTemperature === null ? null : Object(unit_converters["c" /* convertTemperature */])(row.avgTemperature, context.userSettings.units.temperature),

					lowTemperature: row.lowTemperature === null ? null : Math.round(Object(unit_converters["c" /* convertTemperature */])(row.lowTemperature, context.userSettings.units.temperature)),

					highWindGust: row.highWindGust === null ? null : Object(unit_converters["e" /* convertWindSpeed */])(row.highWindGust, context.userSettings.units.speed),

					rainfall: row.rainfall === null ? null : Object(unit_converters["b" /* convertRainfall */])(row.rainfall, context.userSettings.units.rain)

				});
			});
		} else {

			data = props.data;
		}

		return renderList ? Object(preact_min["h"])(daily_list, { data: data, alwaysExpanded: props.listAlwaysExpanded, descending: props.listDescending }) : Object(preact_min["h"])(components_daily_chart, { data: data, w: props.windowWidth });
	};

	return DailyObservations;
}(preact_min["Component"]);

/* harmony default export */ var daily_observations = __webpack_exports__["a"] = (Object(handle_loading_and_error["a" /* default */])(Object(size_aware["a" /* default */])(daily_observations_DailyObservations)));

/***/ })

});


// WEBPACK FOOTER //
// route-live.chunk.6676f.js